import React, { createContext, useRef, useState, useEffect, useContext, useMemo, useCallback, Component, forwardRef } from 'react';
import ReactDom, { render } from 'react-dom';
import 'prosemirror-state';
import 'prosemirror-model';
import { createInstance } from '@sailor/i18n-web';
import 'prosemirror-commands';
import 'prosemirror-inputrules';
import classNames from 'classnames';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var ManagerContext = createContext(null);

var locale = "en";
var version = 16;
var cannot_search_user = "User not found, click space to complete input";
var load_fail_retry = "Failed to load, please try again later";
var pk_avatar = "avatar";
var mention_by_mis_name = "Can @user by name and MIS number";
var searching = "Searching...";
var pk_link_text = "Text";
var insert_blank = "Insert";
var pk_visit_link = "Access the link";
var pk_link_address = "Address";
var pk_link = "Link";
var cancel_blank = "Cancel";
var pk_link_change_tip = "Link text follows the Doc change";
var pk_edit_link = "Edit link";
var pk_link_text_tip = "Input the link text";
var pk_cancel_link = "Cancel link";
var save_blank = "Save";
var pk_link_address_tip = "Input the link address";
var border = "Border";
var pk_insert = "Insert";
var image_link = "Image Link";
var pk_retry = "Retry";
var pk_edit = "Edit";
var width = "Width";
var reupload = "Reupload";
var image_upload_fail1 = "Sorry, upload error!";
var right_address_tip = "Please input right address";
var image_upload_fail3 = "Otherwise, please click button below to retry.";
var image_upload_fail2 = "If the image is moved/pasted from outside, please download and reupload.";
var pk_confirm = "Confirm";
var input_html = "Enter HTML code.";
var formual = "Formual";
var pk_loading = "Loading...";
var click_to_expand = "Click to expand the content";
var pk_cancel = "Cancel";
var input_html_tip = "You can insert HTML code to embed corresponding content on a webpage.";
var input_latex = "Enter Latex code";
var insert_latex_tip = "You can insert Latex code to embed corresponding content within the page.";
var pk_title = "Title";
var wire_frame = "Wireframe";
var fill_in = "Fill";
var input_plantuml = "Enter PlantUML code.";
var border_style = "Border type";
var set_th_line = "Header Column";
var set_th_row = "Header Row";
var table_attr = "Table style";
var cancel_th_line = "Cancel Header Column";
var insert_line_right = "Right Insert Column";
var insert_row = "Delete Rows";
var split_cell = "Split cells";
var delete_line = "Delete Columns";
var pk_no = "No borders";
var input_markdown_tip = "You can insert Markdown code to embed corresponding content within the page.";
var confirm_blank = "Confirm";
var cancel_th_row = "Cancel Header Row";
var insert_row_above = "Insert Row Above";
var delete_table = "Delete";
var input_plantuml_tip = "You can insert PlantUML code to embed corresponding content within the page.";
var border_width = "Border width";
var input_markdown = "Enter Markdown code.";
var merge_cell = "Merge cells";
var set_line_num = "Show Row Number";
var border_color = "Border color";
var insert_line_left = "Left Insert Column";
var insert_row_below = "Insert Row Below";
var cancel_line_num = "Cancel Row Number";
var exit_data_lost_tip = "If you exit, any unsaved data will be lost.";
var if_exit_gantt = "Are you sure to exit the Gantt chart?";
var pk_gantt_loading = "Loading Gantt chart...";
var gantt_load_fail = "Gantt chart loading failed.";
var operate_error = "Invalid operation";
var gantt_keep_work_tip = "Please keep at least one task.";
var save_success = "Save successful";
var gantt_frame_load_fail = "Gantt chart framework failed to load.";
var pk_network_exception = "Network exception";
var save_fail = "Save failed";
var pk_saving = "Saving...";
var gantt_plugin_fail = "Gantt chart editing plugin failed to start.";
var gantt_editing_tip = "Editing Gantt Chart, please wait a moment.";
var pk_discard = "Drop";
var pk_zoom_in = "Zoom in";
var pk_zoom_out = "Zoom out";
var pk_use = "Use";
var draft_edit_tip = "There is a draft that was edited but not saved on {time}. Do you want to continue editing?";
var if_use_local_draft = "Do you use local drafts?";
var pk_load_fail = "Loading failed";
var pk_this_time = "Now";
var choose_time = "Select time";
var pk_hh_mm_ss = "hh:mm:ss A";
var pk_y_d = "MM-DD-YYYY";
var pk_y_d_ts = "MM-DD-YYYY hh:mm:ss A";
var pk_text = "Text";
var h1 = "Heading 1";
var h2 = "Heading 2";
var h3 = "Heading 3";
var h4 = "Heading 4";
var h5 = "Heading 5";
var h6 = "Heading 6";
var pk_catalog = "Catalog";
var page_view_load_fail_click = "Directory tree loading failed. Please click to reload.";
var page_tree_no_sub_doc = "No sub documents found in this directory";
var page_tree_no_perm = "No permission to view the directory tree.";
var pk_load_fail_retry = "Loading failed, please click to reload.";
var loading2 = "Loading";
var page_tree_deleted = "The directory tree has been deleted.";
var pk_pause = "Pause";
var pk_mute = "Mute";
var pk_untitled = "Untitled";
var pk_play = "Play";
var adjust_volume = "Adjust volume";
var download_fail_retry = "Download failed please retry";
var pk_download = "Download";
var get_file_fail = "Failed to get file";
var pk_network_fail = "Network connection failed";
var pk_upload_fail = "Upload failed";
var audio_not_support_tip = "This browser does not support the HTML5 audio tag.";
var pk_volume = "Volume";
var browser_not_support_tip = "This browser does not support the HTML5 video tag.";
var pk_zoom_in2 = "Zoom in";
var video_upload_tip = "Video is being transcoded, if the file is large, it may take a long time. Please wait patiently...";
var pk_video = "Video";
var pk_zoom_out2 = "Zoom out";
var space_update_fail_tip = "Space update acquisition failed. Click to retry.";
var pk_recent_update = "Recent Updates";
var show_more = "Show More";
var no_space_update = "No Updates in Space.";
var pk_restore = "Restore";
var en_parker = {
    locale: locale,
    version: version,
    cannot_search_user: cannot_search_user,
    load_fail_retry: load_fail_retry,
    pk_avatar: pk_avatar,
    mention_by_mis_name: mention_by_mis_name,
    searching: searching,
    pk_link_text: pk_link_text,
    insert_blank: insert_blank,
    pk_visit_link: pk_visit_link,
    pk_link_address: pk_link_address,
    pk_link: pk_link,
    cancel_blank: cancel_blank,
    pk_link_change_tip: pk_link_change_tip,
    pk_edit_link: pk_edit_link,
    pk_link_text_tip: pk_link_text_tip,
    pk_cancel_link: pk_cancel_link,
    save_blank: save_blank,
    pk_link_address_tip: pk_link_address_tip,
    border: border,
    pk_insert: pk_insert,
    image_link: image_link,
    pk_retry: pk_retry,
    pk_edit: pk_edit,
    width: width,
    reupload: reupload,
    image_upload_fail1: image_upload_fail1,
    right_address_tip: right_address_tip,
    image_upload_fail3: image_upload_fail3,
    image_upload_fail2: image_upload_fail2,
    pk_confirm: pk_confirm,
    input_html: input_html,
    formual: formual,
    pk_loading: pk_loading,
    click_to_expand: click_to_expand,
    pk_cancel: pk_cancel,
    input_html_tip: input_html_tip,
    input_latex: input_latex,
    insert_latex_tip: insert_latex_tip,
    pk_title: pk_title,
    wire_frame: wire_frame,
    fill_in: fill_in,
    input_plantuml: input_plantuml,
    border_style: border_style,
    set_th_line: set_th_line,
    set_th_row: set_th_row,
    table_attr: table_attr,
    cancel_th_line: cancel_th_line,
    insert_line_right: insert_line_right,
    insert_row: insert_row,
    split_cell: split_cell,
    delete_line: delete_line,
    pk_no: pk_no,
    input_markdown_tip: input_markdown_tip,
    confirm_blank: confirm_blank,
    cancel_th_row: cancel_th_row,
    insert_row_above: insert_row_above,
    delete_table: delete_table,
    input_plantuml_tip: input_plantuml_tip,
    border_width: border_width,
    input_markdown: input_markdown,
    merge_cell: merge_cell,
    set_line_num: set_line_num,
    border_color: border_color,
    insert_line_left: insert_line_left,
    insert_row_below: insert_row_below,
    cancel_line_num: cancel_line_num,
    exit_data_lost_tip: exit_data_lost_tip,
    if_exit_gantt: if_exit_gantt,
    pk_gantt_loading: pk_gantt_loading,
    gantt_load_fail: gantt_load_fail,
    operate_error: operate_error,
    gantt_keep_work_tip: gantt_keep_work_tip,
    save_success: save_success,
    gantt_frame_load_fail: gantt_frame_load_fail,
    pk_network_exception: pk_network_exception,
    save_fail: save_fail,
    pk_saving: pk_saving,
    gantt_plugin_fail: gantt_plugin_fail,
    gantt_editing_tip: gantt_editing_tip,
    pk_discard: pk_discard,
    pk_zoom_in: pk_zoom_in,
    pk_zoom_out: pk_zoom_out,
    pk_use: pk_use,
    draft_edit_tip: draft_edit_tip,
    if_use_local_draft: if_use_local_draft,
    pk_load_fail: pk_load_fail,
    pk_this_time: pk_this_time,
    choose_time: choose_time,
    pk_hh_mm_ss: pk_hh_mm_ss,
    pk_y_d: pk_y_d,
    pk_y_d_ts: pk_y_d_ts,
    pk_text: pk_text,
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4,
    h5: h5,
    h6: h6,
    pk_catalog: pk_catalog,
    page_view_load_fail_click: page_view_load_fail_click,
    page_tree_no_sub_doc: page_tree_no_sub_doc,
    page_tree_no_perm: page_tree_no_perm,
    pk_load_fail_retry: pk_load_fail_retry,
    loading2: loading2,
    page_tree_deleted: page_tree_deleted,
    pk_pause: pk_pause,
    pk_mute: pk_mute,
    pk_untitled: pk_untitled,
    pk_play: pk_play,
    adjust_volume: adjust_volume,
    download_fail_retry: download_fail_retry,
    pk_download: pk_download,
    get_file_fail: get_file_fail,
    pk_network_fail: pk_network_fail,
    pk_upload_fail: pk_upload_fail,
    audio_not_support_tip: audio_not_support_tip,
    pk_volume: pk_volume,
    browser_not_support_tip: browser_not_support_tip,
    pk_zoom_in2: pk_zoom_in2,
    video_upload_tip: video_upload_tip,
    pk_video: pk_video,
    pk_zoom_out2: pk_zoom_out2,
    space_update_fail_tip: space_update_fail_tip,
    pk_recent_update: pk_recent_update,
    show_more: show_more,
    no_space_update: no_space_update,
    pk_restore: pk_restore
};

var locale$1 = "zh";
var version$1 = 16;
var cannot_search_user$1 = "未搜索到用户，点击空格完成输入";
var load_fail_retry$1 = "加载失败，请稍后重试";
var pk_avatar$1 = "头像";
var mention_by_mis_name$1 = "可通过姓名及mis号@用户";
var searching$1 = "搜索中...";
var pk_link_text$1 = "链接文字";
var insert_blank$1 = "插 入";
var pk_link$1 = "链接";
var pk_link_address$1 = "链接地址";
var pk_visit_link$1 = "访问链接";
var cancel_blank$1 = "取 消";
var pk_link_change_tip$1 = "链接文字跟随文档标题变更";
var pk_edit_link$1 = "编辑链接";
var pk_cancel_link$1 = "取消链接";
var pk_link_text_tip$1 = "请输入链接文字";
var save_blank$1 = "保 存";
var pk_link_address_tip$1 = "请输入链接地址";
var border$1 = "边框";
var pk_insert$1 = "插入";
var image_link$1 = "图片链接";
var pk_edit$1 = "编辑";
var pk_retry$1 = "重试";
var width$1 = "宽度";
var reupload$1 = "重新上传";
var image_upload_fail1$1 = "抱歉，图片上传失败！";
var image_upload_fail3$1 = "否则，请点击下方按钮进行重试。";
var right_address_tip$1 = "请输入正确的地址";
var image_upload_fail2$1 = "如果是从外部拖动、粘贴过来的图片，请下载原图并重新上传。";
var pk_confirm$1 = "确定";
var input_html$1 = "输入HTML代码";
var formual$1 = "公式";
var pk_loading$1 = "正在加载中...";
var pk_cancel$1 = "取消";
var click_to_expand$1 = "点击展开内容";
var input_html_tip$1 = "可以插入HTML代码，以在页面内嵌入相应内容：";
var insert_latex_tip$1 = "可以插入Latex代码，以在页面内嵌入相应内容：";
var input_latex$1 = "输入Latex代码";
var pk_title$1 = "标题";
var wire_frame$1 = "线框";
var fill_in$1 = "填充";
var input_plantuml$1 = "輸入PlantUML代碼";
var border_style$1 = "边框样式";
var set_th_row$1 = "设置表头行";
var set_th_line$1 = "设置表头列";
var table_attr$1 = "表格属性";
var cancel_th_line$1 = "取消表头列";
var insert_row$1 = "删除行";
var insert_line_right$1 = "右侧插入列";
var split_cell$1 = "拆分单元格";
var delete_line$1 = "删除列";
var confirm_blank$1 = "确 定";
var input_markdown_tip$1 = "可以插入Markdown代码，以在页面内嵌入相应内容：";
var pk_no$1 = "无";
var cancel_th_row$1 = "取消表头行";
var insert_row_above$1 = "上方插入行";
var delete_table$1 = "删除表格";
var input_plantuml_tip$1 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容";
var border_width$1 = "边框宽度";
var input_markdown$1 = "输入Markdown代码";
var merge_cell$1 = "合并单元格";
var set_line_num$1 = "设置行号列";
var border_color$1 = "边框颜色";
var insert_line_left$1 = "左侧插入列";
var insert_row_below$1 = "下方插入行";
var cancel_line_num$1 = "取消行号列";
var if_exit_gantt$1 = "确定退出甘特图?";
var exit_data_lost_tip$1 = "退出后，尚未保存的数据将丢失。";
var gantt_load_fail$1 = "甘特图载入失败";
var pk_gantt_loading$1 = "甘特图载入中...";
var operate_error$1 = "您的操作有误";
var gantt_keep_work_tip$1 = "请至少保留一个任务";
var gantt_frame_load_fail$1 = "甘特图框架加载失败";
var save_success$1 = "保存成功";
var save_fail$1 = "保存失败";
var pk_network_exception$1 = "网络异常";
var pk_saving$1 = "正在保存中...";
var gantt_plugin_fail$1 = "甘特图编辑插件启动失败";
var gantt_editing_tip$1 = "正在编辑甘特图，请稍候再试噢。";
var pk_discard$1 = "废弃";
var pk_zoom_in$1 = "放大查看";
var pk_zoom_out$1 = "缩小查看";
var pk_use$1 = "使用";
var draft_edit_tip$1 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继续编辑";
var pk_load_fail$1 = "加载失败";
var if_use_local_draft$1 = "是否使用本地草稿？";
var pk_this_time$1 = "此刻";
var choose_time$1 = "选择时间";
var pk_hh_mm_ss$1 = "HH:mm:ss";
var pk_y_d$1 = "YYYY-MM-DD";
var pk_y_d_ts$1 = "YYYY-MM-DD HH:mm:ss";
var pk_text$1 = "正文";
var h1$1 = "标题 1";
var h2$1 = "标题 2";
var h3$1 = "标题 3";
var h4$1 = "标题 4";
var h5$1 = "标题 5";
var h6$1 = "标题 6";
var pk_catalog$1 = "目录";
var page_view_load_fail_click$1 = "目录树加载失败，请点击重新加载";
var page_tree_no_sub_doc$1 = "该目录下暂无子文档";
var page_tree_no_perm$1 = "无权查看该目录树";
var pk_load_fail_retry$1 = "加载失败，请点击重新加载";
var loading2$1 = "正在加载";
var page_tree_deleted$1 = "该目录树已被删除";
var pk_pause$1 = "暂停";
var pk_mute$1 = "静音";
var pk_untitled$1 = "未命名";
var pk_play$1 = "播放";
var adjust_volume$1 = "音量调节";
var download_fail_retry$1 = "下载失败，请重试";
var get_file_fail$1 = "文件获取失败";
var pk_download$1 = "下载";
var pk_network_fail$1 = "网络连接失败";
var pk_upload_fail$1 = "上传失败";
var audio_not_support_tip$1 = "本浏览器不支持 HTML5 audio 标签";
var browser_not_support_tip$1 = "本浏览器不支持 HTML5 video 标签";
var pk_volume$1 = "音量";
var pk_zoom_in2$1 = "放大";
var pk_video$1 = "视频";
var video_upload_tip$1 = "视频正在转码中，如文件较大可能时间较长，请耐心等待…";
var pk_zoom_out2$1 = "缩小";
var space_update_fail_tip$1 = "空间更新获取失败，点击重试";
var pk_recent_update$1 = "最近更新";
var show_more$1 = "显示更多";
var no_space_update$1 = "空间暂时没有动态～";
var pk_restore$1 = "恢复默认";
var zh_parker = {
    locale: locale$1,
    version: version$1,
    cannot_search_user: cannot_search_user$1,
    load_fail_retry: load_fail_retry$1,
    pk_avatar: pk_avatar$1,
    mention_by_mis_name: mention_by_mis_name$1,
    searching: searching$1,
    pk_link_text: pk_link_text$1,
    insert_blank: insert_blank$1,
    pk_link: pk_link$1,
    pk_link_address: pk_link_address$1,
    pk_visit_link: pk_visit_link$1,
    cancel_blank: cancel_blank$1,
    pk_link_change_tip: pk_link_change_tip$1,
    pk_edit_link: pk_edit_link$1,
    pk_cancel_link: pk_cancel_link$1,
    pk_link_text_tip: pk_link_text_tip$1,
    save_blank: save_blank$1,
    pk_link_address_tip: pk_link_address_tip$1,
    border: border$1,
    pk_insert: pk_insert$1,
    image_link: image_link$1,
    pk_edit: pk_edit$1,
    pk_retry: pk_retry$1,
    width: width$1,
    reupload: reupload$1,
    image_upload_fail1: image_upload_fail1$1,
    image_upload_fail3: image_upload_fail3$1,
    right_address_tip: right_address_tip$1,
    image_upload_fail2: image_upload_fail2$1,
    pk_confirm: pk_confirm$1,
    input_html: input_html$1,
    formual: formual$1,
    pk_loading: pk_loading$1,
    pk_cancel: pk_cancel$1,
    click_to_expand: click_to_expand$1,
    input_html_tip: input_html_tip$1,
    insert_latex_tip: insert_latex_tip$1,
    input_latex: input_latex$1,
    pk_title: pk_title$1,
    wire_frame: wire_frame$1,
    fill_in: fill_in$1,
    input_plantuml: input_plantuml$1,
    border_style: border_style$1,
    set_th_row: set_th_row$1,
    set_th_line: set_th_line$1,
    table_attr: table_attr$1,
    cancel_th_line: cancel_th_line$1,
    insert_row: insert_row$1,
    insert_line_right: insert_line_right$1,
    split_cell: split_cell$1,
    delete_line: delete_line$1,
    confirm_blank: confirm_blank$1,
    input_markdown_tip: input_markdown_tip$1,
    pk_no: pk_no$1,
    cancel_th_row: cancel_th_row$1,
    insert_row_above: insert_row_above$1,
    delete_table: delete_table$1,
    input_plantuml_tip: input_plantuml_tip$1,
    border_width: border_width$1,
    input_markdown: input_markdown$1,
    merge_cell: merge_cell$1,
    set_line_num: set_line_num$1,
    border_color: border_color$1,
    insert_line_left: insert_line_left$1,
    insert_row_below: insert_row_below$1,
    cancel_line_num: cancel_line_num$1,
    if_exit_gantt: if_exit_gantt$1,
    exit_data_lost_tip: exit_data_lost_tip$1,
    gantt_load_fail: gantt_load_fail$1,
    pk_gantt_loading: pk_gantt_loading$1,
    operate_error: operate_error$1,
    gantt_keep_work_tip: gantt_keep_work_tip$1,
    gantt_frame_load_fail: gantt_frame_load_fail$1,
    save_success: save_success$1,
    save_fail: save_fail$1,
    pk_network_exception: pk_network_exception$1,
    pk_saving: pk_saving$1,
    gantt_plugin_fail: gantt_plugin_fail$1,
    gantt_editing_tip: gantt_editing_tip$1,
    pk_discard: pk_discard$1,
    pk_zoom_in: pk_zoom_in$1,
    pk_zoom_out: pk_zoom_out$1,
    pk_use: pk_use$1,
    draft_edit_tip: draft_edit_tip$1,
    pk_load_fail: pk_load_fail$1,
    if_use_local_draft: if_use_local_draft$1,
    pk_this_time: pk_this_time$1,
    choose_time: choose_time$1,
    pk_hh_mm_ss: pk_hh_mm_ss$1,
    pk_y_d: pk_y_d$1,
    pk_y_d_ts: pk_y_d_ts$1,
    pk_text: pk_text$1,
    h1: h1$1,
    h2: h2$1,
    h3: h3$1,
    h4: h4$1,
    h5: h5$1,
    h6: h6$1,
    pk_catalog: pk_catalog$1,
    page_view_load_fail_click: page_view_load_fail_click$1,
    page_tree_no_sub_doc: page_tree_no_sub_doc$1,
    page_tree_no_perm: page_tree_no_perm$1,
    pk_load_fail_retry: pk_load_fail_retry$1,
    loading2: loading2$1,
    page_tree_deleted: page_tree_deleted$1,
    pk_pause: pk_pause$1,
    pk_mute: pk_mute$1,
    pk_untitled: pk_untitled$1,
    pk_play: pk_play$1,
    adjust_volume: adjust_volume$1,
    download_fail_retry: download_fail_retry$1,
    get_file_fail: get_file_fail$1,
    pk_download: pk_download$1,
    pk_network_fail: pk_network_fail$1,
    pk_upload_fail: pk_upload_fail$1,
    audio_not_support_tip: audio_not_support_tip$1,
    browser_not_support_tip: browser_not_support_tip$1,
    pk_volume: pk_volume$1,
    pk_zoom_in2: pk_zoom_in2$1,
    pk_video: pk_video$1,
    video_upload_tip: video_upload_tip$1,
    pk_zoom_out2: pk_zoom_out2$1,
    space_update_fail_tip: space_update_fail_tip$1,
    pk_recent_update: pk_recent_update$1,
    show_more: show_more$1,
    no_space_update: no_space_update$1,
    pk_restore: pk_restore$1
};

var locale$2 = "zh-HK";
var version$2 = 16;
var cannot_search_user$2 = "未能找到用户，請按空格鍵完成輸入";
var load_fail_retry$2 = "載入失敗，請稍後重試。";
var pk_avatar$2 = "頭像";
var mention_by_mis_name$2 = "可通過姓名及MIS號碼@用戶";
var searching$2 = "搜尋中...";
var pk_link_text$2 = "鏈接文字";
var insert_blank$2 = "插 入";
var pk_visit_link$2 = "访问鏈接";
var pk_link_address$2 = "鏈接地址";
var pk_link$2 = "鏈接";
var cancel_blank$2 = "取 消";
var pk_link_change_tip$2 = "鏈接文字跟隨文件標題變更";
var pk_edit_link$2 = "編輯鏈接";
var pk_link_text_tip$2 = "請輸入鏈接文字";
var pk_cancel_link$2 = "取消鏈接";
var save_blank$2 = "保 存";
var pk_link_address_tip$2 = "請輸入鏈接地址";
var border$2 = "邊框";
var pk_insert$2 = "插入";
var image_link$2 = "圖片鏈接";
var pk_retry$2 = "重試";
var pk_edit$2 = "編輯";
var width$2 = "寬度";
var reupload$2 = "重新上傳";
var image_upload_fail1$2 = "抱歉，圖片上傳失敗！";
var right_address_tip$2 = "請輸入正確的地址";
var image_upload_fail3$2 = "否則，請按下方按鈕進行重試。";
var image_upload_fail2$2 = "如果您從外部拖動、粘貼過來的圖片，請下載原圖並重新上傳。";
var pk_confirm$2 = "確定";
var input_html$2 = "輸入HTML代碼";
var formual$2 = "公式";
var pk_loading$2 = "正在載入中...";
var pk_cancel$2 = "取消";
var click_to_expand$2 = "點選展開內容";
var input_html_tip$2 = "可以插入HTML代碼，以在頁面內嵌入相應內容：";
var insert_latex_tip$2 = "可以插入Latex代碼，以在頁面內嵌入相應內容：";
var input_latex$2 = "输入LaTeX代码";
var pk_title$2 = "標題";
var wire_frame$2 = "線框";
var fill_in$2 = "填充";
var input_plantuml$2 = "輸入PlantUML程式碼";
var border_style$2 = "邊框樣式";
var set_th_row$2 = "設置表頭行";
var set_th_line$2 = "設置表頭列";
var table_attr$2 = "表格屬性";
var cancel_th_line$2 = "取消表頭列";
var insert_row$2 = "删除行";
var insert_line_right$2 = "右側插入列";
var split_cell$2 = "拆分儲存格";
var delete_line$2 = "删除列";
var pk_no$2 = "無";
var confirm_blank$2 = "確 定";
var input_markdown_tip$2 = "可以插入Markdown代碼，以在頁面內嵌入相應內容：";
var cancel_th_row$2 = "取消表頭行";
var insert_row_above$2 = "上方插入行";
var delete_table$2 = "刪除表格";
var input_plantuml_tip$2 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容：";
var border_width$2 = "邊框寬度";
var input_markdown$2 = "輸入Markdown代碼";
var merge_cell$2 = "合併儲存格";
var set_line_num$2 = "設置行号列";
var border_color$2 = "邊框顏色";
var insert_line_left$2 = "左側插入列";
var insert_row_below$2 = "下方插入行";
var cancel_line_num$2 = "取消行号列";
var if_exit_gantt$2 = "確定退出甘特圖?";
var exit_data_lost_tip$2 = "退出後，尚未儲存的數據將會遺失。";
var pk_gantt_loading$2 = "甘特圖載入中...";
var gantt_load_fail$2 = "甘特圖載入失敗";
var operate_error$2 = "您的操作有誤";
var gantt_keep_work_tip$2 = "請至少保留一個任務";
var save_success$2 = "保存成功";
var gantt_frame_load_fail$2 = "甘特圖框架載入失敗";
var save_fail$2 = "保存失敗";
var pk_network_exception$2 = "網絡異常";
var pk_saving$2 = "正在儲存中...";
var gantt_plugin_fail$2 = "甘特圖編輯插件啟動失敗。";
var gantt_editing_tip$2 = "正在編輯甘特圖，請稍後再試唷。";
var pk_discard$2 = "廢棄";
var pk_zoom_in$2 = "放大查看";
var pk_zoom_out$2 = "縮小查看";
var pk_use$2 = "使用";
var draft_edit_tip$2 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继續編輯";
var pk_load_fail$2 = "加載失敗";
var if_use_local_draft$2 = "是否使用本地草稿？";
var pk_this_time$2 = "此刻";
var choose_time$2 = "選擇時間";
var pk_hh_mm_ss$2 = "HH:mm:ss";
var pk_y_d$2 = "YYYY-MM-DD";
var pk_y_d_ts$2 = "YYYY-MM-DD HH:mm:ss";
var pk_text$2 = "正文";
var h1$2 = "標題 1";
var h2$2 = "標題 2";
var h3$2 = "標題 3";
var h4$2 = "標題 4";
var h5$2 = "標題 5";
var h6$2 = "標題 6";
var pk_catalog$2 = "目錄";
var page_view_load_fail_click$2 = "目錄樹加載失敗，請點擊重新加載。";
var page_tree_no_sub_doc$2 = "該目錄下暫無子文檔。";
var page_tree_no_perm$2 = "無權查看該目錄樹";
var pk_load_fail_retry$2 = "加載失敗，請點擊重新加載。";
var loading2$2 = "正在載入";
var page_tree_deleted$2 = "該目錄樹已被刪除";
var pk_pause$2 = "暫停";
var pk_mute$2 = "靜音";
var pk_untitled$2 = "未命名";
var pk_play$2 = "播放";
var adjust_volume$2 = "音量調節";
var download_fail_retry$2 = "下載失敗，請重試";
var pk_download$2 = "下載";
var get_file_fail$2 = "文件獲取失敗";
var pk_network_fail$2 = "網絡連接失敗";
var pk_upload_fail$2 = "上載失敗";
var audio_not_support_tip$2 = "本瀏覽器不支援 HTML5 audio 標籤";
var pk_volume$2 = "音量";
var browser_not_support_tip$2 = "本瀏覽器不支援 HTML5 video 標籤";
var pk_zoom_in2$2 = "放大";
var video_upload_tip$2 = "視頻正在轉碼中，如果文件較大可能需要較長的時間，請耐心等待...";
var pk_video$2 = "視頻";
var pk_zoom_out2$2 = "縮小";
var space_update_fail_tip$2 = "空間更新獲取失敗，點擊重試";
var pk_recent_update$2 = "最近更新";
var show_more$2 = "顯示更多";
var no_space_update$2 = "空間暫時沒有動態～";
var pk_restore$2 = "恢復預設";
var zhHK_parker = {
    locale: locale$2,
    version: version$2,
    cannot_search_user: cannot_search_user$2,
    load_fail_retry: load_fail_retry$2,
    pk_avatar: pk_avatar$2,
    mention_by_mis_name: mention_by_mis_name$2,
    searching: searching$2,
    pk_link_text: pk_link_text$2,
    insert_blank: insert_blank$2,
    pk_visit_link: pk_visit_link$2,
    pk_link_address: pk_link_address$2,
    pk_link: pk_link$2,
    cancel_blank: cancel_blank$2,
    pk_link_change_tip: pk_link_change_tip$2,
    pk_edit_link: pk_edit_link$2,
    pk_link_text_tip: pk_link_text_tip$2,
    pk_cancel_link: pk_cancel_link$2,
    save_blank: save_blank$2,
    pk_link_address_tip: pk_link_address_tip$2,
    border: border$2,
    pk_insert: pk_insert$2,
    image_link: image_link$2,
    pk_retry: pk_retry$2,
    pk_edit: pk_edit$2,
    width: width$2,
    reupload: reupload$2,
    image_upload_fail1: image_upload_fail1$2,
    right_address_tip: right_address_tip$2,
    image_upload_fail3: image_upload_fail3$2,
    image_upload_fail2: image_upload_fail2$2,
    pk_confirm: pk_confirm$2,
    input_html: input_html$2,
    formual: formual$2,
    pk_loading: pk_loading$2,
    pk_cancel: pk_cancel$2,
    click_to_expand: click_to_expand$2,
    input_html_tip: input_html_tip$2,
    insert_latex_tip: insert_latex_tip$2,
    input_latex: input_latex$2,
    pk_title: pk_title$2,
    wire_frame: wire_frame$2,
    fill_in: fill_in$2,
    input_plantuml: input_plantuml$2,
    border_style: border_style$2,
    set_th_row: set_th_row$2,
    set_th_line: set_th_line$2,
    table_attr: table_attr$2,
    cancel_th_line: cancel_th_line$2,
    insert_row: insert_row$2,
    insert_line_right: insert_line_right$2,
    split_cell: split_cell$2,
    delete_line: delete_line$2,
    pk_no: pk_no$2,
    confirm_blank: confirm_blank$2,
    input_markdown_tip: input_markdown_tip$2,
    cancel_th_row: cancel_th_row$2,
    insert_row_above: insert_row_above$2,
    delete_table: delete_table$2,
    input_plantuml_tip: input_plantuml_tip$2,
    border_width: border_width$2,
    input_markdown: input_markdown$2,
    merge_cell: merge_cell$2,
    set_line_num: set_line_num$2,
    border_color: border_color$2,
    insert_line_left: insert_line_left$2,
    insert_row_below: insert_row_below$2,
    cancel_line_num: cancel_line_num$2,
    if_exit_gantt: if_exit_gantt$2,
    exit_data_lost_tip: exit_data_lost_tip$2,
    pk_gantt_loading: pk_gantt_loading$2,
    gantt_load_fail: gantt_load_fail$2,
    operate_error: operate_error$2,
    gantt_keep_work_tip: gantt_keep_work_tip$2,
    save_success: save_success$2,
    gantt_frame_load_fail: gantt_frame_load_fail$2,
    save_fail: save_fail$2,
    pk_network_exception: pk_network_exception$2,
    pk_saving: pk_saving$2,
    gantt_plugin_fail: gantt_plugin_fail$2,
    gantt_editing_tip: gantt_editing_tip$2,
    pk_discard: pk_discard$2,
    pk_zoom_in: pk_zoom_in$2,
    pk_zoom_out: pk_zoom_out$2,
    pk_use: pk_use$2,
    draft_edit_tip: draft_edit_tip$2,
    pk_load_fail: pk_load_fail$2,
    if_use_local_draft: if_use_local_draft$2,
    pk_this_time: pk_this_time$2,
    choose_time: choose_time$2,
    pk_hh_mm_ss: pk_hh_mm_ss$2,
    pk_y_d: pk_y_d$2,
    pk_y_d_ts: pk_y_d_ts$2,
    pk_text: pk_text$2,
    h1: h1$2,
    h2: h2$2,
    h3: h3$2,
    h4: h4$2,
    h5: h5$2,
    h6: h6$2,
    pk_catalog: pk_catalog$2,
    page_view_load_fail_click: page_view_load_fail_click$2,
    page_tree_no_sub_doc: page_tree_no_sub_doc$2,
    page_tree_no_perm: page_tree_no_perm$2,
    pk_load_fail_retry: pk_load_fail_retry$2,
    loading2: loading2$2,
    page_tree_deleted: page_tree_deleted$2,
    pk_pause: pk_pause$2,
    pk_mute: pk_mute$2,
    pk_untitled: pk_untitled$2,
    pk_play: pk_play$2,
    adjust_volume: adjust_volume$2,
    download_fail_retry: download_fail_retry$2,
    pk_download: pk_download$2,
    get_file_fail: get_file_fail$2,
    pk_network_fail: pk_network_fail$2,
    pk_upload_fail: pk_upload_fail$2,
    audio_not_support_tip: audio_not_support_tip$2,
    pk_volume: pk_volume$2,
    browser_not_support_tip: browser_not_support_tip$2,
    pk_zoom_in2: pk_zoom_in2$2,
    video_upload_tip: video_upload_tip$2,
    pk_video: pk_video$2,
    pk_zoom_out2: pk_zoom_out2$2,
    space_update_fail_tip: space_update_fail_tip$2,
    pk_recent_update: pk_recent_update$2,
    show_more: show_more$2,
    no_space_update: no_space_update$2,
    pk_restore: pk_restore$2
};

// This file was auto generated by resource-sync tools.
var resources = {
    "en": {
        parker: en_parker
    },
    "zh": {
        parker: zh_parker
    },
    "zh-HK": {
        parker: zhHK_parker
    }
};

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var I18nManager = /*#__PURE__*/ function() {
    function I18nManager() {
        _classCallCheck(this, I18nManager);
    }
    I18nManager.getInstance = function getInstance() {
        if (this.instance === null) {
            this.instance = createInstance();
            this.instance.init({
                // lng: 'zh',
                fallbackLng: "zh",
                ns: [
                    "parker"
                ],
                defaultNS: "parker",
                resources: resources,
                interpolation: {
                    escapeValue: false
                },
                react: {
                    useSuspense: false
                }
            });
            window.parkerI18nClient = this.instance;
        }
        return this.instance;
    };
    return I18nManager;
}();
I18nManager.instance = null;
var i18nClient = I18nManager.getInstance();

var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eredo%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='redo' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cpath d='M32%2c15.5 L17%2c15.5 C12.0294373%2c15.5 8%2c19.5294373 8%2c24.5 C8%2c29.4705627 12.0294373%2c33.5 17%2c33.5 L23%2c33.5 L23%2c36.5 L17%2c36.5 C10.372583%2c36.5 5%2c31.127417 5%2c24.5 C5%2c17.872583 10.372583%2c12.5 17%2c12.5 L32%2c12.5 L32%2c8 L42%2c14 L32%2c20 L32%2c15.5 Z' fill='black' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eundo-o%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='undo-o' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf' opacity='0'%3e %3cg%3e %3crect id='%e7%9f%a9%e5%bd%a2' fill='white' fill-rule='nonzero' x='0' y='0' width='48' height='48'%3e%3c/rect%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' cx='24' cy='24' r='19.9'%3e%3c/circle%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' cx='24' cy='24' r='9.9'%3e%3c/circle%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='6.1' y='6.1' width='35.8' height='35.8' rx='2'%3e%3c/rect%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='8.1' y='4.1' width='31.8' height='39.8' rx='2'%3e%3c/rect%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='4.1' y='8.1' width='39.8' height='31.8' rx='2'%3e%3c/rect%3e %3c/g%3e %3c/g%3e %3cpath d='M15%2c15.5 L15%2c20 L5%2c14 L15%2c8 L15%2c12.5 L30%2c12.5 C36.627417%2c12.5 42%2c17.872583 42%2c24.5 C42%2c31.127417 36.627417%2c36.5 30%2c36.5 L24%2c36.5 L24%2c33.5 L30%2c33.5 C34.9705627%2c33.5 39%2c29.4705627 39%2c24.5 C39%2c19.5294373 34.9705627%2c15.5 30%2c15.5 L15%2c15.5 Z' id='%e8%b7%af%e5%be%84' fill='black' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3ecleaner-format%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='cleaner-format' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M13.64035%2c38 L5.29289322%2c29.6525433 C4.90236893%2c29.262019 4.90236893%2c28.628854 5.29289322%2c28.2383297 L27.2132034%2c6.31801948 C27.6037277%2c5.92749519 28.2368927%2c5.92749519 28.627417%2c6.31801948 L42.0624458%2c19.7530483 C42.4529701%2c20.1435726 42.4529701%2c20.7767376 42.0624458%2c21.1672619 L25.2297077%2c38 L42%2c38 L42%2c41 L6%2c41 L6%2c38 L13.64035%2c38 Z M17.8829906%2c38 L20.987067%2c38 L28.627417%2c30.35965 L18.0208153%2c19.7530483 L8.82842712%2c28.9454365 L17.8829906%2c38 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg t='1570526541657' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3542' width='20px' height='20px'%3e %3cpath d='M679.936 496.32A213.269333 213.269333 0 0 1 789.333333 682.666667c0 117.824-95.509333 213.333333-213.333333 213.333333H234.666667V128h298.666666c117.824 0 213.333333 95.509333 213.333334 213.333333a212.736 212.736 0 0 1-66.730667 154.986667zM320 213.333333v256h213.333333a128 128 0 1 0 0-256H320z m0 341.333334v256h256a128 128 0 1 0 0-256H320z' fill='black' p-id='3543'%3e%3c/path%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cg id='italic' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpolygon id='%e8%b7%af%e5%be%84' fill-opacity='0.87' fill='black' points='18.5777988 38 26.0803762 10 19 10 19 7 37 7 37 10 29.1862047 10 21.6836273 38 29 38 29 41 11 41 11 38'%3e%3c/polygon%3e %3c/g%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 58 (84663) - https://sketch.com --%3e %3ctitle%3eserikeethrough%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='serikeethrough' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M15.9778223%2c22 C14.1310934%2c20.3006928 13%2c18.0144246 13%2c15.5 C13%2c10.2532949 17.9248678%2c6 24%2c6 C29.8809333%2c6 34.6839659%2c9.98571764 34.985026%2c15 L31.9766833%2c15 C31.6624526%2c11.6437761 28.2112183%2c9 24%2c9 C19.581722%2c9 16%2c11.9101491 16%2c15.5 C16%2c19.0898509 19.581722%2c22 24%2c22 L42%2c22 L42%2c25 L32.5697194%2c25 C34.691618%2c26.8037507 36%2c29.2745466 36%2c32 C36%2c37.5228475 30.627417%2c42 24%2c42 C17.372583%2c42 12%2c37.5228475 12%2c32 L15%2c32 C15%2c35.8659932 19.0294373%2c39 24%2c39 C28.9705627%2c39 33%2c35.8659932 33%2c32 C33%2c28.1340068 28.9705627%2c25 24%2c25 L6%2c25 L6%2c22 L15.9778223%2c22 Z' id='%e8%b7%af%e5%be%84' fill-opacity='0.87' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eunderlined%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='underlined' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c39 L42%2c39 L42%2c42 L6%2c42 L6%2c39 Z M36%2c21 C36%2c27.627417 30.627417%2c33 24%2c33 C17.372583%2c33 12%2c27.627417 12%2c21 L12%2c6 L15%2c6 L15%2c21 C15%2c25.9705627 19.0294373%2c30 24%2c30 C28.9705627%2c30 33%2c25.9705627 33%2c21 L33%2c6 L36%2c6 L36%2c21 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg t='1570610575022' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3713' width='20' height='20'%3e %3cpath d='M209.92 128l184.746667 320 184.746666-320h73.92L431.616 512l221.717333 384H579.413333L394.666667 576 209.92 896H136.021333l221.696-384L136.021333 128H209.92zM896 533.333333v79.018667L769.194667 832H896v64h-192v-79.061333L830.784 597.333333H704v-64h192z' fill='black' p-id='3714'%3e%3c/path%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg t='1570610555276' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3542' width='20' height='20'%3e %3cpath d='M209.92 128l184.746667 320 184.746666-320h73.92L431.616 512l221.717333 384H579.413333L394.666667 576 209.92 896H136.021333l221.696-384L136.021333 128H209.92zM896 128v64h-3.626667l-110.848 192H896v64h-192v-64h3.626667l110.848-192H704V128h192z' fill='black' p-id='3543'%3e%3c/path%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3ealign-left%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='align-left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M6%2c17 L32%2c17 L32%2c20 L6%2c20 L6%2c17 Z M6%2c28 L42%2c28 L42%2c31 L6%2c31 L6%2c28 Z M6%2c39 L32%2c39 L32%2c42 L6%2c42 L6%2c39 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3ealign-center%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='align-center' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M12%2c17 L36%2c17 L36%2c20 L12%2c20 L12%2c17 Z M6%2c28 L42%2c28 L42%2c31 L6%2c31 L6%2c28 Z M12%2c39 L36%2c39 L36%2c42 L12%2c42 L12%2c39 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$b = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3ealign-right%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='align-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M16%2c17 L42%2c17 L42%2c20 L16%2c20 L16%2c17 Z M6%2c28 L42%2c28 L42%2c31 L6%2c31 L6%2c28 Z M16%2c39 L42%2c39 L42%2c42 L16%2c42 L16%2c39 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$c = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eform%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='form' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M39%2c28 L39%2c21 L31%2c21 L31%2c28 L39%2c28 Z M39%2c31 L31%2c31 L31%2c39 L28%2c39 L28%2c31 L20%2c31 L20%2c39 L17%2c39 L17%2c31 L9%2c31 L9%2c39 L39%2c39 L39%2c31 Z M9%2c28 L17%2c28 L17%2c21 L9%2c21 L9%2c28 Z M20%2c28 L28%2c28 L28%2c21 L20%2c21 L20%2c28 Z M39%2c18 L39%2c9 L9%2c9 L9%2c18 L17%2c18 L17%2c9 L20%2c9 L20%2c18 L28%2c18 L28%2c9 L31%2c9 L31%2c18 L39%2c18 Z M7%2c6 L41%2c6 C41.5522847%2c6 42%2c6.44771525 42%2c7 L42%2c41 C42%2c41.5522847 41.5522847%2c42 41%2c42 L7%2c42 C6.44771525%2c42 6%2c41.5522847 6%2c41 L6%2c7 C6%2c6.44771525 6.44771525%2c6 7%2c6 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$d = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3elist-bulleted%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='list-bulleted' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M16%2c6.5 L42%2c6.5 L42%2c9.5 L16%2c9.5 L16%2c6.5 Z M16%2c22.5 L42%2c22.5 L42%2c25.5 L16%2c25.5 L16%2c22.5 Z M16%2c38.5 L42%2c38.5 L42%2c41.5 L16%2c41.5 L16%2c38.5 Z M6%2c5 L12%2c5 L12%2c11 L6%2c11 L6%2c5 Z M6%2c37 L12%2c37 L12%2c43 L6%2c43 L6%2c37 Z M6%2c21 L12%2c21 L12%2c27 L6%2c27 L6%2c21 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$e = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3elist-numbered%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='list-numbered' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M16%2c7.5 L42%2c7.5 L42%2c10.5 L16%2c10.5 L16%2c7.5 Z M16%2c22.5 L42%2c22.5 L42%2c25.5 L16%2c25.5 L16%2c22.5 Z M16%2c37.5 L42%2c37.5 L42%2c40.5 L16%2c40.5 L16%2c37.5 Z M6%2c37 L6%2c35 L12%2c35 L12%2c43 L6%2c43 L6%2c41 L10%2c41 L10%2c40 L8%2c40 L8%2c38 L10%2c38 L10%2c37 L6%2c37 Z M8%2c13 L8%2c7 L6%2c7 L6%2c5 L10%2c5 L10%2c13 L8%2c13 Z M6%2c22 L6%2c20 L12%2c20 L12%2c21.8 L8.4%2c26 L12%2c26 L12%2c28 L6%2c28 L6%2c26.2 L9.6%2c22 L6%2c22 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$f = "data:image/svg+xml,%3csvg t='1571829329378' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3632' width='20' height='20'%3e %3cpath d='M192 832h640V192H192v640zM149.333333 128h725.333334a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333z m311.68 458.133333l229.738667-210.496 45.248 45.248-259.904 241.749334a21.333333 21.333333 0 0 1-29.610667-0.533334l-136.192-136.106666 45.269334-45.269334 105.472 105.386667z' fill='black' p-id='3633'%3e%3c/path%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e%3ctitle%3eoutdent-o%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg id='outdent-o' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M6%2c39 L42%2c39 L42%2c42 L6%2c42 L6%2c39 Z M21%2c17 L42%2c17 L42%2c20 L21%2c20 L21%2c17 Z M21%2c28 L42%2c28 L42%2c31 L21%2c31 L21%2c28 Z M16%2c18 L16%2c30 L6%2c24 L16%2c18 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";

var img$h = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eindent-o%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='indent-o' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M6%2c39 L42%2c39 L42%2c42 L6%2c42 L6%2c39 Z M21%2c17 L42%2c17 L42%2c20 L21%2c20 L21%2c17 Z M21%2c28 L42%2c28 L42%2c31 L21%2c31 L21%2c28 Z M6%2c18 L16%2c24 L6%2c30 L6%2c18 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$i = "data:image/svg+xml,%3csvg t='1570540641644' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8522' width='20' height='20'%3e %3cpath d='M896 170.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v341.333333c0 151.125333-71.424 285.546667-182.357333 371.413334l-39.125333-50.666667c93.653333-72.490667 154.730667-185.088 157.397333-312.064L853.333333 533.333333v-21.333333H597.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V192a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667zM426.666667 170.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v341.333333h-0.469333c-6.4 142.4-76.202667 268.288-181.888 350.08l-39.125334-50.666666C322.304 758.613333 384 642.517333 384 512H128a21.333333 21.333333 0 0 1-21.333333-21.333333V192a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667z m426.666666 64H640v213.333333h213.333333V234.666667z m-469.333333 0H170.666667v213.333333h213.333333V234.666667z' fill='black' p-id='8523'%3e%3c/path%3e%3c/svg%3e";

var img$j = "data:image/svg+xml,%3csvg t='1570540555700' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8009' width='20' height='20'%3e %3cpath d='M640 344.405333V298.666667h64v277.333333c0 28.053333 13.312 54.4 35.456 65.536 13.376 6.72 37.973333 6.122667 49.984 0.064C814.933333 628.693333 832 585.258667 832 512c0-178.346667-114.709333-316.650667-275.349333-338.346667l-0.064-0.106666A344.554667 344.554667 0 0 0 512 170.666667C323.477333 170.666667 170.666667 323.477333 170.666667 512s152.810667 341.333333 341.333333 341.333333c97.408 0 185.28-40.789333 247.466667-106.24l46.4 44.074667A404.181333 404.181333 0 0 1 512 917.333333C288.149333 917.333333 106.666667 735.850667 106.666667 512S288.149333 106.666667 512 106.666667c31.488-0.021333 62.890667 3.626667 93.546667 10.858666l-0.042667 0.213334C779.136 160.256 896 320.064 896 512c0 89.429333-23.210667 159.146667-77.653333 186.688-26.944 13.653333-73.152 17.386667-107.669334 0a121.472 121.472 0 0 1-49.386666-45.802667C622.378667 709.845333 560.426667 746.666667 490.666667 746.666667c-117.824 0-213.333333-105.066667-213.333334-234.666667s95.509333-234.666667 213.333334-234.666667c58.133333 0 110.848 25.6 149.333333 67.072zM490.666667 682.666667c82.474667 0 149.333333-76.416 149.333333-170.666667s-66.858667-170.666667-149.333333-170.666667-149.333333 76.416-149.333334 170.666667 66.858667 170.666667 149.333334 170.666667z' fill='black' p-id='8010'%3e%3c/path%3e%3c/svg%3e";

var img$k = "data:image/svg+xml,%3csvg t='1570539962562' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='7496' width='20' height='20'%3e %3cpath d='M330.986667 602.517333a64 64 0 0 0 90.496 90.496L753.365333 361.173333a128 128 0 0 0-181.034666-181.013333L225.386667 527.082667a192 192 0 1 0 271.530666 271.530666l301.696-301.696 45.248 45.248-301.696 301.696c-99.968 99.989333-262.058667 99.989333-362.026666 0-99.989333-99.968-99.989333-262.058667 0-362.026666L527.082667 134.869333A192 192 0 1 1 798.613333 406.4L466.752 738.282667a128 128 0 1 1-181.034667-181.034667l286.613334-286.613333 45.269333 45.269333-286.613333 286.613333z' fill='black' p-id='7497'%3e%3c/path%3e%3c/svg%3e";

var img$l = "data:image/svg+xml,%3csvg t='1570526878627' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4226' width='20' height='20'%3e %3cpath d='M149.333333 640l234.666667-234.666667 234.666667 234.666667 128-128 128 128V234.666667H149.333333v405.333333z m0 90.517333V789.333333h725.333334v-58.816l-128-128-128 128-234.666667-234.666666-234.666667 234.666666zM938.666667 192v640a21.333333 21.333333 0 0 1-21.333334 21.333333H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333333V192a21.333333 21.333333 0 0 1 21.333334-21.333333h810.666666a21.333333 21.333333 0 0 1 21.333334 21.333333zM618.666667 448a64 64 0 1 1 0-128 64 64 0 0 1 0 128z' fill='black' p-id='4227'%3e%3c/path%3e%3c/svg%3e";

var img$m = "data:image/svg+xml,%3csvg t='1570526679287' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3713' width='20px' height='20px'%3e %3cpath d='M532.897959 828.959347c-98.09502 98.09502-257.170286 98.09502-355.265306 0-98.09502-98.115918-98.09502-257.170286 0-355.265306l44.408163 44.408163a188.416 188.416 0 1 0 266.44898 266.44898l44.408163 44.408163z m310.251102-311.463184l-44.617143-44.617143A188.436898 188.436898 0 0 0 533.733878 208.060082L489.095837 163.422041c98.701061-83.654531 246.742204-78.931592 339.86351 14.189714 93.121306 93.121306 97.844245 241.162449 14.210612 339.86351zM177.632653 473.694041l103.612082-103.63298 44.408163 44.408163-103.612082 103.63298L177.632653 473.694041z m207.245061-207.245061l103.612082-103.612082L532.897959 207.245061l-103.612081 103.612082-44.408164-44.408163z m103.612082 518.102204l103.612082-103.63298 44.408163 44.408163-103.612082 103.63298-44.408163-44.408163zM392.275592 569.887347l177.632653-177.632653 44.408163 44.408163-177.632653 177.632653-44.408163-44.408163z m303.438367 7.397877l103.653878-103.612081 44.387265 44.408163-103.612082 103.612082-44.408163-44.408164z' fill='black' p-id='3714'%3e%3c/path%3e%3c/svg%3e";

var img$n = "data:image/svg+xml,%3csvg t='1570540581206' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8180' width='20' height='20'%3e %3cpath d='M874.666667 554.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v298.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V576a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334z m-42.666667 64H192v213.333333h640V618.666667z m42.666667-490.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v320a21.333333 21.333333 0 0 1-21.333333 21.333334H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333334V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334z m-42.666667 64H192v234.666667h640V192z m-512 85.333333v64h-64v-64h64z m128 0v64h-64v-64h64z m128 0v64h-64v-64h64z' fill='black' p-id='8181'%3e%3c/path%3e%3c/svg%3e";

var img$o = "data:image/svg+xml,%3csvg t='1570540670507' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8693' width='20' height='20'%3e %3cpath d='M938.666667 746.666667v64H405.333333v-64h533.333334z m0-192v64H405.333333v-64h533.333334z m0-192v64H405.333333v-64h533.333334zM341.333333 170.666667l-128 213.333333L85.333333 170.666667h256z m597.333334 0v64H405.333333V170.666667h533.333334z' fill='black' p-id='8694'%3e%3c/path%3e%3c/svg%3e";

var img$p = "data:image/svg+xml,%3csvg t='1570540722887' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9035' width='20' height='20'%3e %3cpath d='M362.666667 384l106.666666 181.333333h-74.666666V640H576a21.333333 21.333333 0 0 1 21.333333 21.333333v213.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V661.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h181.333334v-74.666667H256l106.666667-181.333333zM576 128a21.333333 21.333333 0 0 1 21.333333 21.333333v74.666667h320a21.333333 21.333333 0 0 1 21.333334 21.333333v533.333334a21.333333 21.333333 0 0 1-21.333334 21.333333h-138.666666V874.666667L597.333333 768l181.333334-106.666667v74.666667H874.666667v-448H597.333333V362.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h426.666667z m-42.666667 576H192v128h341.333333v-128z m0-512H192v128h341.333333V192z' fill='black' p-id='9036'%3e%3c/path%3e%3c/svg%3e";

var img$q = "data:image/svg+xml,%3csvg t='1570540758107' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9377' width='20' height='20'%3e %3cpath d='M533.333333 128v64H213.333333v192h256v64H213.333333v448H149.333333V128h384z m334.954667 176.213333l55.424 32L772.949333 597.333333l150.762667 261.12-55.424 32L736 661.333333l-132.288 229.12-55.424-32L699.050667 597.333333l-150.762667-261.12 55.424-32L736 533.333333l132.288-229.12z' fill='black' p-id='9378'%3e%3c/path%3e%3c/svg%3e";

var img$r = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%a2%91%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-70.000000%2c -386.000000)'%3e %3cg id='%e9%9f%b3%e9%a2%91' transform='translate(70.000000%2c 386.000000)'%3e %3crect id='Rectangle-16' fill='%23D8D8D8' opacity='0' x='0' y='0' width='16' height='16'%3e%3c/rect%3e %3cpath d='M12.7445743%2c2.04437642 L7.03505843%2c3.63603963 C6.34056761%2c3.81829114 5.78631052%2c4.47439658 5.78631052%2c5.10012677 L5.78631052%2c10.5737472 C5.78631052%2c10.5737472 5.37228715%2c10.3185951 4.45075125%2c10.4400961 C3.0951586%2c10.6162725 2%2c11.5579053 2%2c12.5481385 C2%2c13.5383718 3.0951586%2c14.1458768 4.45075125%2c13.9697003 C5.80634391%2c13.7935239 6.79465776%2c12.8822663 6.79465776%2c11.8920331 L6.79465776%2c6.60673927 C6.79465776%2c6.16933564 7.37562604%2c5.98100908 7.37562604%2c5.98100908 L12.4240401%2c4.54122213 C12.4240401%2c4.54122213 12.984975%2c4.37112072 12.984975%2c4.8388996 L12.984975%2c9.20078578 C12.984975%2c9.20078578 12.4707846%2c8.93348357 11.5492487%2c9.03068437 C10.1936561%2c9.18256063 9.0984975%2c10.1059683 9.0984975%2c11.0962015 C9.0984975%2c12.0864347 10.1936561%2c12.7121649 11.5492487%2c12.5663637 C12.9048414%2c12.4144874 14%2c11.4910798 14%2c10.5008466 L14%2c2.85235813 C13.9933222%2c2.23270299 13.4323873%2c1.86819996 12.7445743%2c2.04437642 Z' id='Shape' fill='%23666666' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e %3cg id='Group-6' transform='translate(70.000000%2c 349.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$s = "data:image/svg+xml,%3csvg t='1570526758806' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3884' width='20px' height='20px'%3e %3cpath d='M704 704h-128v-64h128v64zM149.333333 128h725.333334a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333z m42.666667 64v640h640V192H192z m146.752 469.333333l148.032-148.053333-148.053333-148.032L384 320l178.218667 178.218667a21.333333 21.333333 0 0 1 0 30.165333L384 706.56 338.752 661.333333z' fill='black' p-id='3885'%3e%3c/path%3e%3c/svg%3e";

var img$t = "data:image/svg+xml,%3csvg t='1570540612741' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8351' width='20' height='20'%3e %3cpath d='M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m0 64C311.701333 149.333333 149.333333 311.701333 149.333333 512s162.368 362.666667 362.666667 362.666667 362.666667-162.368 362.666667-362.666667S712.298667 149.333333 512 149.333333z m42.666667 234.666667h-85.333334v-85.333333h85.333334v85.333333z m0 341.333333h-85.333334V448h85.333334v277.333333z' fill='black' p-id='8352'%3e%3c/path%3e%3c/svg%3e";

var img$u = "data:image/svg+xml,%3csvg t='1570540694172' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8864' width='20' height='20'%3e %3cpath d='M938.666667 640v64H85.333333v-64h853.333334z m0-320v64H85.333333v-64h853.333334z' fill='black' p-id='8865'%3e%3c/path%3e%3c/svg%3e";

var img$v = "data:image/svg+xml,%3csvg t='1570540740273' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9206' width='20' height='20'%3e %3cpath d='M405.333333 618.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333333V405.333333a21.333333 21.333333 0 0 1 21.333334-21.333333h277.333333a21.333333 21.333333 0 0 1 21.333333 21.333333v74.666667h85.333334v-234.666667a21.333333 21.333333 0 0 1 21.333333-21.333333h106.645333L618.666667 149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h277.333333a21.333333 21.333333 0 0 1 21.333334 21.333333v213.333334a21.333333 21.333333 0 0 1-21.333334 21.333333H640a21.333333 21.333333 0 0 1-21.333333-21.333333l-0.021334-74.666667H554.666667v448h63.978666L618.666667 661.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h277.333333a21.333333 21.333333 0 0 1 21.333334 21.333333v213.333334a21.333333 21.333333 0 0 1-21.333334 21.333333H640a21.333333 21.333333 0 0 1-21.333333-21.333333l-0.021334-74.666667H512a21.333333 21.333333 0 0 1-21.333333-21.333333v-234.666667h-85.333334V618.666667z m-64-170.666667H149.333333v128h192v-128zM874.666667 192h-192v128h192V192z m0 512h-192v128h192v-128z' fill='black' p-id='9207'%3e%3c/path%3e%3c/svg%3e";

var img$w = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e8%a7%86%e9%a2%91%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-70.000000%2c -358.000000)'%3e %3cg id='%e8%a7%86%e9%a2%91' transform='translate(70.000000%2c 358.000000)'%3e %3cg id='Group'%3e %3crect id='Rectangle-24' fill='%23D8D8D8' opacity='0' x='0' y='0' width='16' height='16'%3e%3c/rect%3e %3cg id='Group-3' transform='translate(1.000000%2c 2.000000)' fill='%23666666'%3e %3cpath d='M1%2c0 L13%2c0 C13.5522847%2c-1.01453063e-16 14%2c0.44771525 14%2c1 L14%2c11 C14%2c11.5522847 13.5522847%2c12 13%2c12 L1%2c12 C0.44771525%2c12 6.76353751e-17%2c11.5522847 0%2c11 L0%2c1 C-6.76353751e-17%2c0.44771525 0.44771525%2c1.01453063e-16 1%2c0 Z M1%2c1 L1%2c11 L13%2c11 L13%2c1 L1%2c1 Z' id='Combined-Shape'%3e%3c/path%3e %3cpath d='M2%2c3 L2%2c1 L3%2c1 L3%2c11 L2%2c11 L2%2c9 L1%2c9 L1%2c7 L2%2c7 L2%2c5 L1%2c5 L1%2c3 L2%2c3 Z M12%2c3 L13%2c3 L13%2c5 L12%2c5 L12%2c7 L13%2c7 L13%2c9 L12%2c9 L12%2c11 L11%2c11 L11%2c1 L12%2c1 L12%2c3 Z M5.77249258%2c3.50211599 L8.97045947%2c5.58077715 C9.20198985%2c5.73127065 9.26768323%2c6.0409622 9.11718974%2c6.27249258 C9.07907871%2c6.33112541 9.0290923%2c6.38111182 8.97045947%2c6.41922285 L5.77249258%2c8.49788401 C5.5409622%2c8.6483775 5.23127065%2c8.58268412 5.08077715%2c8.35115374 C5.02805948%2c8.27004895 5%2c8.17539347 5%2c8.07866116 L5%2c3.92133884 C5%2c3.64519646 5.22385763%2c3.42133884 5.5%2c3.42133884 C5.59673231%2c3.42133884 5.69138779%2c3.44939832 5.77249258%2c3.50211599 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group-6' transform='translate(70.000000%2c 349.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$x = "data:image/svg+xml,%3csvg t='1570540788356' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9548' width='20' height='20'%3e %3cpath d='M874.666667 128a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334z m-42.666667 64H192v640h640V192z m-405.333333 106.666667v181.333333h170.666666V298.666667h64v426.666666h-64v-181.333333h-170.666666V725.333333h-64V298.666667h64z' fill='black' p-id='9549'%3e%3c/path%3e%3c/svg%3e";

var img$y = "data:image/svg+xml,%3csvg t='1570540806818' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9719' width='20' height='20'%3e %3cpath d='M512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m0-64c200.298667 0 362.666667-162.368 362.666667-362.666667S712.298667 149.333333 512 149.333333 149.333333 311.701333 149.333333 512s162.368 362.666667 362.666667 362.666667z m10.666667-375.914667l139.946666 139.946667-45.226666 45.269333-149.333334-149.333333A32 32 0 0 1 458.666667 512V298.666667h64v200.085333z' fill='black' p-id='9720'%3e%3c/path%3e%3c/svg%3e";

var img$z = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='32px' height='32px' viewBox='0 0 32 32' enable-background='new 0 0 32 32' xml:space='preserve'%3e %3cimage id='image0' width='32' height='32' x='0' y='0' href='data:image/png%3bbase64%2ciVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQflCxYHJA0C6ZJdAAAA30lEQVRIx%2b2UOw6CQBCGPyxIcGPtIWjxMFZ6H219YDRYeQbDBWxsOQWIDf1YuBIeAeJiQeFMszOz82f%2bfx/wtyGYYkeCGHjCFgUHo%2baP%2b5AieEazewgPCwEsQ/oCo74SFgHerJZ5vNSZ6o7aGFIqZ7gAuGSdAILUAYQIhSLK4y8BIoSAQK8MAD6jZ7hmADBHEBalhnXlAq3aAODEsZKxOBfaL/r0GgEcnNrINqGOQ%2bx2Ck2cx9wQ7ky6NGgWbcqVabk%2bhLfwBMPnPANS8Ht9KHtQbImNmmM2qL4S/O0X9gLetRuVuh38BwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0xMS0yMlQwNzozNjowOSswMDowMIa6WUUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMTEtMjJUMDc6MzY6MDkrMDA6MDD35%2bH5AAAAAElFTkSuQmCC' /%3e%3c/svg%3e";

// 行内样式
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var MenuMarkType = {
    Font: "font",
    Bold: "strong",
    Italic: "em",
    Strikethrough: "strikethrough",
    Underline: "underline",
    Color: "color",
    Sub: "sub",
    Sup: "sup",
    Subsup: "subsup"
};
// 位置排版
var MenuComposeType = {
    ClearFormat: "clearFormat",
    Align: "align",
    Indent: "indent"
};
// 宏节点
var MenuNodeType = {
    Heading: "heading",
    Table: "table",
    Mention: "mention",
    Attachment: "attachment",
    Image: "image",
    Link: "link",
    Code: "code_block",
    Extra: "extra",
    Status: "status",
    Drawio: "drawio",
    Video: "video",
    Audio: "audio",
    Collapse: "collapse",
    Catalog: "catalog",
    Minder: "minder",
    PlantUML: "plantuml",
    Time: "time",
    Latex: "latex_inline",
    Markdown: "markdown",
    Html: "html",
    HorizontalRule: "horizontal_rule",
    Note: "note",
    Calendar: "calendar",
    Data2Chart: "data2chart",
    Gantt: "gantt",
    PageTree: "page_tree",
    SpaceUpdate: "space_update"
};
// 容器节点
var MenuWrapType = {
    BulletList: "bullet_list",
    OrderedList: "ordered_list",
    TaskList: "task_list",
    Blockquote: "blockquote"
};
// 历史记录
var MenuHistoryType = {
    History: "history"
};
var MenuType = _objectSpread({}, MenuMarkType, MenuComposeType, MenuNodeType, MenuWrapType, MenuHistoryType);
var fontSizeConfig = [
    {
        title: "9",
        fontSize: 12,
        lineHeight: 24
    },
    {
        title: "10",
        fontSize: 13,
        lineHeight: 24
    },
    {
        title: "11",
        fontSize: 14,
        lineHeight: 24
    },
    {
        title: "12",
        fontSize: 16,
        lineHeight: 24
    },
    {
        title: "14",
        fontSize: 19,
        lineHeight: 27
    },
    {
        title: "16",
        fontSize: 22,
        lineHeight: 30
    },
    {
        title: "18",
        fontSize: 24,
        lineHeight: 32
    },
    {
        title: "22",
        fontSize: 29,
        lineHeight: 37
    },
    {
        title: "24",
        fontSize: 32,
        lineHeight: 40
    },
    {
        title: "30",
        fontSize: 40,
        lineHeight: 48
    },
    {
        title: "36",
        fontSize: 48,
        lineHeight: 56
    }
];
// 以 fontsize 的 title 为 key，fontSize 为 value 的Map
var fontSizeTitleMap = fontSizeConfig.reduce(function(ret, item) {
    return _objectSpreadProps(_objectSpread({}, ret), _defineProperty({}, +item.title, item.fontSize));
}, {});
var getMenuInfo = function(type, manager, config) {
    switch(type){
        case MenuType.History:
            if (!manager.commands.history) return null;
            return [
                {
                    title: "撤销",
                    icon: img$1,
                    command: manager.commands.history.undo,
                    isActive: function() {
                        return false;
                    },
                    isDisabled: manager.commands.history.isUndoDisabled
                },
                {
                    command: manager.commands.history.redo,
                    title: "重做",
                    icon: img,
                    isActive: function() {
                        return false;
                    },
                    isDisabled: manager.commands.history.isRedoDisabled
                }
            ];
        case MenuType.ClearFormat:
            {
                if (!manager.commands.clear) return null;
                return [
                    {
                        title: "清除格式",
                        icon: img$2,
                        command: manager.commands.clear.clearMark,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.clear.isDisabled
                    }
                ];
            }
        case MenuType.Heading:
            {
                var _manager_commands_code_block;
                if (!manager.commands.heading) return null;
                var titles = [
                    i18nClient.t("pk_text", "正文"),
                    i18nClient.t("h1", "标题 1"),
                    i18nClient.t("h2", "标题 2"),
                    i18nClient.t("h3", "标题 3"),
                    i18nClient.t("h4", "标题 4"),
                    i18nClient.t("h5", "标题 5"),
                    i18nClient.t("h6", "标题 6")
                ];
                if (config === null || config === void 0 ? void 0 : config.level) {
                    titles = [
                        "正文"
                    ];
                    config.level.forEach(function(levelNum) {
                        titles.push("标题 ".concat(levelNum));
                    });
                }
                var isDisabled = ((_manager_commands_code_block = manager.commands.code_block) === null || _manager_commands_code_block === void 0 ? void 0 : _manager_commands_code_block.isInCode()) || false;
                return titles.map(function(title) {
                    if (title === "正文") {
                        return {
                            title: title,
                            icon: img$3,
                            command: function() {
                                return manager.commands.paragraph.setParagraph();
                            },
                            isDisabled: function() {
                                return isDisabled;
                            }
                        };
                    }
                    return {
                        title: title,
                        icon: img$3,
                        command: function() {
                            return manager.commands.heading.setHeading(parseInt(title.split(" ")[1], 10));
                        },
                        isDisabled: function() {
                            return isDisabled;
                        }
                    };
                });
            }
        case MenuType.Font:
            {
                if (!manager.commands.font) return null;
                return [
                    9,
                    10,
                    11,
                    12,
                    14,
                    16,
                    18,
                    22,
                    24,
                    30,
                    36
                ].map(function(size) {
                    return {
                        command: function() {
                            manager.commands.font.setSize(fontSizeTitleMap[size]);
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return manager.commands.font.isDisabled();
                        },
                        title: "".concat(size)
                    };
                });
            }
        case MenuType.Bold:
            {
                if (!manager.commands.strong) return null;
                return [
                    {
                        title: "粗体",
                        icon: img$3,
                        keyTips: "⌘-B",
                        command: function() {
                            return manager.commands.strong.toggleStrong();
                        },
                        isActive: function() {
                            return manager.commands.strong.isStrongActive();
                        },
                        isDisabled: function() {
                            return manager.commands.strong.isStrongDisabled();
                        }
                    }
                ];
            }
        case MenuType.Italic:
            {
                if (!manager.commands.em) return null;
                return [
                    {
                        title: "斜体",
                        icon: img$4,
                        keyTips: "⌘-I",
                        command: function() {
                            return manager.commands.em.toggleItalic();
                        },
                        isActive: function() {
                            return manager.commands.em.isItalicActive();
                        },
                        isDisabled: function() {
                            return manager.commands.em.isItalicDisabled();
                        }
                    }
                ];
            }
        case MenuType.Strikethrough:
            {
                if (!manager.commands.strikethrough) return null;
                return [
                    {
                        title: "中划线",
                        icon: img$5,
                        keyTips: "⌘-⇧-S",
                        command: function() {
                            return manager.commands.strikethrough.toggleStrikethrough();
                        },
                        isActive: function() {
                            return manager.commands.strikethrough.isStrikethroughActive();
                        },
                        isDisabled: function() {
                            return manager.commands.strikethrough.isStrikethroughDisabled();
                        }
                    }
                ];
            }
        case MenuType.Underline:
            {
                if (!manager.commands.underline) return null;
                return [
                    {
                        title: "下划线",
                        icon: img$6,
                        keyTips: "⌘-U",
                        command: function() {
                            return manager.commands.underline.toggleUnderline();
                        },
                        isActive: function() {
                            return manager.commands.underline.isUnderlineActive();
                        },
                        isDisabled: function() {
                            return manager.commands.underline.isUnderlineDisabled();
                        }
                    }
                ];
            }
        case MenuType.Color:
            {
                if (!manager.commands.color) return null;
                return [
                    {
                        command: function(color) {
                            return manager.commands.color.setColor(color);
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return manager.commands.color.isDisabled();
                        },
                        title: "文字颜色"
                    }
                ];
            }
        case MenuType.Sub:
            {
                if (!manager.commands.sub) return null;
                return [
                    {
                        title: "下标",
                        icon: img$7,
                        command: function() {
                            return manager.commands.sub.toggle();
                        },
                        isActive: function() {
                            return manager.commands.sub.isActive();
                        },
                        isDisabled: function() {
                            return manager.commands.sub.isDisabled();
                        }
                    }
                ];
            }
        case MenuType.Sup:
            {
                if (!manager.commands.sup) return null;
                return [
                    {
                        title: "上标",
                        icon: img$8,
                        command: function() {
                            return manager.commands.sup.toggle();
                        },
                        isActive: function() {
                            return manager.commands.sup.isActive();
                        },
                        isDisabled: function() {
                            return manager.commands.sup.isDisabled();
                        }
                    }
                ];
            }
        case MenuType.Align:
            {
                if (!manager.commands.align) return null;
                return [
                    {
                        title: "左对齐",
                        icon: img$9,
                        command: function() {
                            return manager.commands.align.setAlign("left");
                        },
                        isActive: function() {
                            return manager.commands.align.isAlignActive("left");
                        },
                        isDisabled: function() {
                            return manager.commands.align.isAlignDisabled();
                        }
                    },
                    {
                        title: "居中",
                        icon: img$a,
                        command: function() {
                            return manager.commands.align.setAlign("center");
                        },
                        isActive: function() {
                            return manager.commands.align.isAlignActive("center");
                        },
                        isDisabled: function() {
                            return manager.commands.align.isAlignDisabled();
                        }
                    },
                    {
                        title: "右对齐",
                        icon: img$b,
                        command: function() {
                            return manager.commands.align.setAlign("right");
                        },
                        isActive: function() {
                            return manager.commands.align.isAlignActive("right");
                        },
                        isDisabled: function() {
                            return manager.commands.align.isAlignDisabled();
                        }
                    }
                ];
            }
        case MenuType.Table:
            {
                var _manager_commands_code_block1;
                if (!manager.commands.table) return null;
                var isDisabled1 = ((_manager_commands_code_block1 = manager.commands.code_block) === null || _manager_commands_code_block1 === void 0 ? void 0 : _manager_commands_code_block1.isInCode()) || false;
                return [
                    {
                        title: "表格",
                        icon: img$c,
                        command: function(args) {
                            return manager.commands.table.insertTable(args);
                        },
                        isDisabled: function() {
                            return isDisabled1;
                        },
                        isActive: function() {
                            return true;
                        }
                    }
                ];
            }
        case MenuType.BulletList:
            {
                if (!manager.commands.bullet_list) return null;
                return [
                    {
                        title: "无序列表",
                        icon: img$d,
                        keyTips: "⌘-⇧-U",
                        command: function() {
                            return manager.commands.bullet_list.handleListClick();
                        },
                        isDisabled: function() {
                            return manager.commands.bullet_list.isBulletListDisabled();
                        },
                        isActive: function() {
                            return manager.commands.bullet_list.isBulletListActive();
                        }
                    }
                ];
            }
        case MenuType.OrderedList:
            {
                if (!manager.commands.ordered_list) return null;
                return [
                    {
                        title: "有序列表",
                        icon: img$e,
                        keyTips: "⌘-⇧-O",
                        command: function() {
                            return manager.commands.ordered_list.handleListClick();
                        },
                        isDisabled: function() {
                            return manager.commands.ordered_list.isOrderedListDisabled();
                        },
                        isActive: function() {
                            return manager.commands.ordered_list.isOrderedListActive();
                        }
                    }
                ];
            }
        case MenuType.TaskList:
            {
                if (!manager.commands.task_list) return null;
                return [
                    {
                        title: "任务列表",
                        icon: img$f,
                        command: function() {
                            return manager.commands.task_list.handleListClick();
                        },
                        isDisabled: function() {
                            return manager.commands.task_list.isTaskListDisabled();
                        },
                        isActive: function() {
                            return manager.commands.task_list.isTaskListActive();
                        }
                    }
                ];
            }
        case MenuType.Indent:
            {
                if (!manager.commands.indent) return null;
                return [
                    {
                        title: "减少缩进",
                        icon: img$g,
                        command: function() {
                            return manager.commands.indent.indentLess();
                        },
                        isDisabled: function() {
                            return manager.commands.indent.isIndentLessDisabled();
                        },
                        isActive: function() {
                            return false;
                        }
                    },
                    {
                        title: "增加缩进",
                        icon: img$h,
                        command: function() {
                            return manager.commands.indent.indentMore();
                        },
                        isDisabled: function() {
                            return manager.commands.indent.isIndentMoreDisabled();
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Code:
            {
                if (!manager.commands.code_block) return null;
                return [
                    {
                        title: "代码块",
                        icon: img$s,
                        command: function() {
                            return manager.commands.code_block.insert();
                        },
                        isDisabled: function() {
                            return manager.commands.code_block.isCodeBlockDisabled();
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Blockquote:
            {
                if (!manager.commands.blockquote) return null;
                return [
                    {
                        title: "引用",
                        icon: img$i,
                        command: manager.commands.blockquote.toggle,
                        isDisabled: function() {
                            return false;
                        },
                        isActive: manager.commands.blockquote.isActive
                    }
                ];
            }
        case MenuType.Mention:
            {
                if (!manager.commands.mention) return null;
                return [
                    {
                        title: "用户提及",
                        icon: img$j,
                        command: function() {
                            // TODO: 临时策略，不用settimeout会导致插入后弹框会自动消失，怀疑是其他宏的state更新影响
                            setTimeout(function() {
                                manager.commands.mention.insertAtMention();
                            }, 0);
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.mention.isMentionDisabled
                    }
                ];
            }
        case MenuType.Attachment:
            {
                if (!manager.commands.attachment) return null;
                return [
                    {
                        title: "附件",
                        icon: img$k,
                        command: function() {
                            manager.commands.attachment.upload();
                        },
                        isDisabled: function() {
                            return false;
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Image:
            {
                if (!manager.commands.image) return null;
                return [
                    {
                        title: "图片",
                        icon: img$l,
                        command: function() {
                            return manager.commands.image.upload();
                        },
                        isDisabled: function() {
                            return false;
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Link:
            {
                if (!manager.commands.link) return null;
                return [
                    {
                        title: "链接",
                        icon: img$m,
                        keyTips: "⌘-K",
                        command: function() {
                            return manager.commands.link.edit();
                        },
                        isDisabled: function() {
                            return manager.commands.link.isDisabled();
                        },
                        isActive: function() {
                            return manager.commands.link.isActive();
                        }
                    }
                ];
            }
        case MenuType.Status:
            {
                if (!manager.commands.status) return null;
                return [
                    {
                        title: "状态",
                        icon: img$n,
                        command: manager.commands.status.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.status.isDisabled
                    }
                ];
            }
        case MenuType.Audio:
            {
                if (!manager.commands.audio) return null;
                return [
                    {
                        title: "音频",
                        icon: img$r,
                        command: function() {
                            return manager.commands.audio.upload();
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.audio.isDisabled
                    }
                ];
            }
        case MenuType.Collapse:
            {
                if (!manager.commands.collapse) return null;
                return [
                    {
                        title: "展开",
                        icon: img$o,
                        command: function() {
                            return manager.commands.collapse.insert();
                        }
                    }
                ];
            }
        case MenuType.Catalog:
            {
                if (!manager.commands.catalog) return null;
                return [
                    {
                        title: "目录",
                        icon: img$i,
                        command: function() {
                            return manager.commands.catalog.insert();
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.catalog.isDisabled
                    }
                ];
            }
        case MenuType.Drawio:
            {
                if (!manager.commands.drawio) return null;
                return [
                    {
                        title: "流程图",
                        icon: img$p,
                        command: manager.commands.drawio.insertDrawio,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.drawio.isDisabled
                    }
                ];
            }
        case MenuType.Minder:
            {
                if (!manager.commands.minder) return null;
                return [
                    {
                        title: "思维导图",
                        icon: img$v,
                        command: manager.commands.minder.insertMinder,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.minder.isDisabled
                    }
                ];
            }
        case MenuType.PlantUML:
            {
                if (!manager.commands.plantuml) return null;
                return [
                    {
                        title: "PlantUML",
                        icon: img$v,
                        command: manager.commands.plantuml.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.plantuml.isDisabled
                    }
                ];
            }
        case MenuType.Time:
            {
                if (!manager.commands.time) return null;
                return [
                    {
                        title: "时间",
                        icon: img$y,
                        command: manager.commands.time.insertTime,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.time.isDisabled
                    }
                ];
            }
        case MenuType.Latex:
            {
                if (!manager.commands.latex_inline) return null;
                return [
                    {
                        title: "公式",
                        icon: img$q,
                        command: manager.commands.latex_inline.insertLatex,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.latex_inline.isLatexDisabled
                    }
                ];
            }
        case MenuType.Markdown:
            {
                if (!manager.commands.markdown) return null;
                return [
                    {
                        title: "Markdown",
                        icon: img$z,
                        command: manager.commands.markdown.insertMarkdown,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.markdown.isMarkdownDisabled
                    }
                ];
            }
        case MenuType.Html:
            {
                if (!manager.commands.html) return null;
                return [
                    {
                        title: "HTML",
                        icon: img$x,
                        command: manager.commands.html.insertHtml,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.html.isHtmlDisabled
                    }
                ];
            }
        case MenuType.Video:
            {
                if (!manager.commands.video) return null;
                return [
                    {
                        title: "视频",
                        icon: img$w,
                        command: manager.commands.video.upload,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.video.isDisabled
                    }
                ];
            }
        case MenuType.Note:
            {
                if (!manager.commands.note) return null;
                return [
                    {
                        title: "信息",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("info");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    },
                    {
                        title: "警示",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("note");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    },
                    {
                        title: "注意",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("warning");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    },
                    {
                        title: "提示",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("tip");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.HorizontalRule:
            {
                if (!manager.commands.horizontal_rule) return null;
                return [
                    {
                        title: "水平线",
                        icon: img$u,
                        command: function() {
                            manager.commands.horizontal_rule.insertHr();
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return manager.commands.horizontal_rule.isHrDisabled();
                        }
                    }
                ];
            }
        case MenuType.Calendar:
            {
                if (!manager.commands.calendar) return null;
                return [
                    {
                        title: "日历",
                        icon: img$q,
                        command: manager.commands.calendar.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Data2Chart:
            {
                if (!manager.commands.data2chart) return null;
                return [
                    {
                        title: "数据图表",
                        icon: img$p,
                        command: manager.commands.data2chart.edit,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.data2chart.isDisabled
                    }
                ];
            }
        case MenuType.Gantt:
            {
                if (!manager.commands.gantt) return null;
                return [
                    {
                        title: "甘特图",
                        icon: "",
                        command: manager.commands.gantt.insertGantt,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.gantt.isDisabled
                    }
                ];
            }
        case MenuType.PageTree:
            {
                if (!manager.commands.page_tree) return null;
                return [
                    {
                        title: "目录树",
                        icon: img$f,
                        command: manager.commands.page_tree.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.page_tree.isDisabled
                    }
                ];
            }
        case MenuType.SpaceUpdate:
            {
                if (!manager.commands.spaceupdate) return null;
                return [
                    {
                        title: "最近更新",
                        icon: img$f,
                        command: manager.commands.spaceupdate.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.spaceupdate.isDisabled
                    }
                ];
            }
        default:
            return null;
    }
};
// 色板
var colors = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];

var img$A = "data:image/svg+xml,%3csvg t='1570526843158' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4055' width='20' height='20'%3e %3cpath d='M234.666667 448a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m277.333333 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m277.333333 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z' fill='black' p-id='4056'%3e%3c/path%3e%3c/svg%3e";

// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

var img$B = "data:image/svg+xml,%3csvg t='1571562690312' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3602' width='16' height='16'%3e %3cpath d='M521.898667 666.773333a10.666667 10.666667 0 0 1-18.453334 0l-173.461333-298.752a10.666667 10.666667 0 0 1 9.216-16.021333h346.944a10.666667 10.666667 0 0 1 9.216 16.021333l-173.461333 298.752z' fill='black' opacity='0.38' p-id='3603'%3e%3c/path%3e%3c/svg%3e";

var TriggerItem = function(param) {
    var className = param.className, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, children = param.children;
    return /*#__PURE__*/ React.createElement("div", {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: classNames(classNamePrefix("trigger-popup-item"), className)
    }, children);
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".ct-trigger{position:relative;display:flex;justify-content:center;align-items:center}.ct-trigger-popup{background:#fff;position:absolute;padding:4px 0;box-shadow:0 2px 4px 0 rgba(0,0,0,.02),0 4px 6px 6px rgba(0,0,0,.02),0 4px 6px 0 rgba(0,0,0,.06);border-radius:4px;display:none;z-index:1000;font-family:PingFangSC-Regular}.ct-trigger-popup-show{display:block}.ct-trigger-popup-hidden{display:none}.ct-trigger-popup-item{display:flex;align-items:center;padding:8px 0 8px 16px;cursor:pointer}.ct-trigger-popup-item.divider{border-bottom:1px solid #ddd}.ct-trigger-popup-item:hover{background:rgba(0,0,0,.07)}.ct-trigger-popup-item img{margin:0 8px 0 0;width:20px;height:20px}";
styleInject(css_248z);

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ITriggerAlign;
(function(ITriggerAlign) {
    ITriggerAlign["LEFT"] = "left";
    ITriggerAlign["RIGHT"] = "right";
    ITriggerAlign["TOP"] = "top";
    ITriggerAlign["BOTTOM"] = "bottom";
})(ITriggerAlign || (ITriggerAlign = {}));
var ITriggerType;
(function(ITriggerType) {
    ITriggerType["CLICK"] = "click";
    ITriggerType["HOVER"] = "hover";
})(ITriggerType || (ITriggerType = {}));
var THRESHOLD = 10;
var Trigger = function(param) {
    var children = param.children, popup = param.popup, _param_align = param.align, align = _param_align === void 0 ? ITriggerAlign.RIGHT : _param_align, _param_trigger = param.trigger, trigger = _param_trigger === void 0 ? ITriggerType.HOVER : _param_trigger, visible = param.visible, width = param.width, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    var node = useRef(null);
    var popNode = useRef(null);
    var getStyle = function() {
        if (node.current && popNode.current) {
            var height = node.current.offsetHeight;
            var popWidth = popNode.current.offsetWidth;
            var popHeight = popNode.current.offsetHeight;
            switch(align){
                case ITriggerAlign.RIGHT:
                    {
                        return {
                            right: -popWidth - THRESHOLD,
                            top: -(popHeight - height) / 2
                        };
                    }
                case ITriggerAlign.LEFT:
                    {
                        return {
                            left: -popWidth - THRESHOLD,
                            top: -(popHeight - height) / 2
                        };
                    }
                case ITriggerAlign.BOTTOM:
                    {
                        return {
                            left: 0,
                            top: node.current.offsetHeight
                        };
                    }
                case ITriggerAlign.TOP:
                    {
                        return {
                            left: 0,
                            top: -popHeight - THRESHOLD
                        };
                    }
                default:
                    return {};
            }
        }
    };
    var _obj;
    var eventMapper = (_obj = {}, _defineProperty$1(_obj, ITriggerType.HOVER, {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }), _defineProperty$1(_obj, ITriggerType.CLICK, {
        onClick: onClick
    }), _obj);
    return /*#__PURE__*/ React.createElement("div", _extends({
        className: classNamePrefix("trigger")
    }, eventMapper[trigger]), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("trigger-children"),
        ref: node
    }, children), /*#__PURE__*/ React.createElement("div", {
        className: classNames(classNamePrefix("trigger-popup"), visible ? classNamePrefix("trigger-popup-show") : classNamePrefix("trigger-popup-hidden")),
        ref: popNode,
        style: _objectSpreadProps$1(_objectSpread$1({}, getStyle()), {
            width: width || "100%"
        })
    }, popup));
};
Trigger.Item = TriggerItem;

var css_248z$1 = '.ct-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:#292929;border-radius:4px;z-index:100;display:none}.ct-tooltip-wrapper{line-height:1;position:relative}.ct-tooltip-disabled{display:none}.ct-tooltip-active{display:block}.ct-tooltip-active:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:#292929 transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:100}.ct-tooltip-top{top:-35px}.ct-tooltip-top:after{bottom:-5px;top:auto;border-width:5px 5px 0}';
styleInject(css_248z$1);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var prefixCls = classNamePrefix("tooltip");
var Tooltips = function(props) {
    var title = props.title, disabled = props.disabled, children = props.children, _props_placement = props.placement, placement = _props_placement === void 0 ? "bottom" : _props_placement;
    var _useState = _slicedToArray(useState(false), 2), isHover = _useState[0], toggleHover = _useState[1];
    var onMouseEnter = function(e) {
        if (!disabled) {
            toggleHover(true);
        }
    };
    var onMouseLeave = function() {
        toggleHover(false);
    };
    var _obj;
    return /*#__PURE__*/ React.createElement("div", {
        className: "".concat(prefixCls, "-wrapper"),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, children, title && /*#__PURE__*/ React.createElement("div", {
        className: classNames("".concat(prefixCls), "".concat(prefixCls, "-").concat(placement), (_obj = {}, _defineProperty$2(_obj, "".concat(prefixCls, "-active"), isHover && !disabled), _defineProperty$2(_obj, "".concat(prefixCls, "-disabled"), disabled), _obj))
    }, title));
};

var css_248z$2 = ".ct-menubar-dropdown{position:relative;height:28px;box-sizing:border-box;display:flex;padding:0 16px 0 0;border-radius:1000px;cursor:pointer;transition:all .3s;align-items:center;white-space:nowrap}.ct-menubar-dropdown-disabled{cursor:not-allowed;opacity:.3}.ct-menubar-dropdown.ct-menubar-extra{padding-right:3px}.ct-menubar-dropdown .arrow{position:absolute;top:6px;right:4px;display:inline-flex;border-radius:6px;height:16px}.ct-menubar-dropdown:hover{background:rgba(0,0,0,.07)}.ct-menubar-dropdown .text{padding:0 4px 0 7px;font-size:14px;color:#000;text-align:center}.ct-menubar-dropdown .icon{padding:0 4px 0 7px}";
styleInject(css_248z$2);

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
var Dropdown = function(props) {
    var tips = props.tips, hasArrow = props.hasArrow, icon = props.icon, title = props.title, className = props.className, isDisabled = props.isDisabled, popup = props.popup, trigger = props.trigger, align = props.align, width = props.width, buttonWidth = props.buttonWidth, children = props.children, onVisibleChange = props.onVisibleChange;
    var _useState = _slicedToArray$1(useState(false), 2), visible = _useState[0], toggleVisible = _useState[1];
    var triggerRef = useRef(null);
    var onClickOutside = function(e) {
        var target = e.target;
        if (!triggerRef.current.contains(target)) {
            setTimeout(function() {
                toggleVisible(false);
            }, 50);
        }
    };
    var onClickTarget = function() {
        if (!isDisabled) {
            setTimeout(function() {
                toggleVisible(!visible);
            }, 100);
        }
    };
    useEffect(function() {
        if (onVisibleChange) {
            onVisibleChange(visible);
        }
    }, [
        visible
    ]);
    var onMouseEnter = function() {
        setTimeout(function() {
            toggleVisible(true);
        }, 200);
    };
    var onMouseLeave = function() {
        setTimeout(function() {
            toggleVisible(false);
        }, 200);
    };
    useEffect(function() {
        document.addEventListener(ITriggerType.CLICK, onClickOutside);
        return function() {
            document.removeEventListener(ITriggerType.CLICK, onClickOutside);
        };
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: triggerRef
    }, /*#__PURE__*/ React.createElement(Trigger, {
        popup: popup,
        trigger: trigger,
        align: align,
        visible: visible,
        width: width,
        onClick: onClickTarget,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ React.createElement(Tooltips, {
        title: tips,
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames(classNamePrefix("menubar-dropdown"), classNamePrefix("menubar-item"), className, isDisabled ? classNamePrefix("menubar-dropdown-disabled") : "", visible ? classNamePrefix("menubar-dropdown-active") : ""),
        style: {
            width: buttonWidth
        }
    }, icon && /*#__PURE__*/ React.createElement("img", {
        src: icon,
        className: "icon",
        alt: tips
    }), !icon && title && /*#__PURE__*/ React.createElement("span", {
        className: "text"
    }, title), hasArrow && /*#__PURE__*/ React.createElement("span", {
        className: "arrow"
    }, /*#__PURE__*/ React.createElement("img", {
        src: img$B,
        alt: "triangle"
    })), children))));
};
Dropdown.defaultProps = {
    hasArrow: false,
    icon: null,
    title: null,
    isDisabled: false,
    isActive: true,
    trigger: ITriggerType.CLICK,
    align: ITriggerAlign.BOTTOM,
    width: 52,
    buttonWidth: "auto",
    className: ""
};

var css_248z$3 = ".ct-extra-collapse-item-wrapper{position:absolute;left:118px;padding:8px 0 3px;width:80px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 2px 4px 0 rgba(0,0,0,.02),0 4px 6px 6px rgba(0,0,0,.02),0 4px 6px 0 rgba(0,0,0,.06)}.ct-extra-collapse-item-wrapper .ct-extra-collapse-item{height:26px;padding:5px 10px;cursor:pointer;font-size:14px;color:#333}.ct-extra-collapse-item-wrapper .ct-extra-collapse-item:hover{background-color:#f6f6f6}";
styleInject(css_248z$3);

function _arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$2(arr, i) {
    return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}
function _unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
var ExtraCollapseItem = function(param) {
    var itemlist = param.itemlist, title = param.title, icon = param.icon, divider = param.divider;
    var manager = useContext(ManagerContext);
    var _useState = _slicedToArray$2(useState(false), 2), showPopover = _useState[0], setShowPopover = _useState[1];
    var handleClick = function(e, command) {
        e.target.closest(".".concat(classNamePrefix("trigger-popup"))).click();
        command();
        manager.editorView.focus();
    };
    return /*#__PURE__*/ React.createElement(Trigger.Item, {
        key: title,
        className: divider ? "divider" : "",
        onClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onMouseEnter: function() {
            setShowPopover(true);
        },
        onMouseLeave: function() {
            setShowPopover(false);
        }
    }, icon && /*#__PURE__*/ React.createElement("img", {
        src: icon,
        alt: title
    }), /*#__PURE__*/ React.createElement("span", null, title), showPopover && /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("extra-collapse-item-wrapper")
    }, itemlist.map(function(item, index) {
        var itemTitle = item.title, command = item.command;
        return /*#__PURE__*/ React.createElement("div", {
            className: classNamePrefix("extra-collapse-item"),
            onClick: function(e) {
                return handleClick(e, command);
            },
            key: index
        }, /*#__PURE__*/ React.createElement("div", null, itemTitle));
    })));
};

function _arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}
var ExtraItem = function(param) {
    var menuList = param.menuList;
    var manager = useContext(ManagerContext);
    var onClickItem = function(command, type) {
        command();
        // 需要聚焦在 modal 上的特殊处理
        if (![
            "link",
            "html",
            "markdown",
            "plantuml"
        ].includes(type)) {
            manager.editorView.focus();
        }
    };
    var list = useMemo(function() {
        return menuList.reduce(function(prev, cur) {
            var type = cur.type, divider = cur.divider, config = cur.config;
            var infoList = getMenuInfo(type, manager);
            if (!infoList) return prev;
            if (type === "note") {
                var title = "样式";
                return _toConsumableArray(prev).concat([
                    /*#__PURE__*/ React.createElement(ExtraCollapseItem, {
                        itemlist: infoList,
                        key: title,
                        title: title,
                        icon: infoList[0].icon,
                        divider: divider
                    })
                ]);
            }
            var itemList = infoList.map(function(info) {
                var title = info.title, icon = info.icon, command = info.command;
                return /*#__PURE__*/ React.createElement(Trigger.Item, {
                    key: title,
                    onClick: function() {
                        return onClickItem(command, type);
                    },
                    className: divider ? "divider" : ""
                }, icon && /*#__PURE__*/ React.createElement("img", {
                    src: icon,
                    alt: title
                }), /*#__PURE__*/ React.createElement("span", null, title));
            });
            return _toConsumableArray(prev).concat(_toConsumableArray(itemList));
        }, []);
    }, [
        menuList
    ]);
    var isDisabled = !canInsertTypes(manager.editorView.state);
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 120,
        tips: "插入其他",
        className: classNamePrefix("menubar-extra"),
        icon: img$A,
        isDisabled: isDisabled,
        buttonWidth: 28
    });
};

var css_248z$4 = ".ct-menubar-item{height:28px;width:28px;cursor:pointer;display:flex;align-items:center;justify-content:center;margin:auto 4px;border-radius:14px;transition:all .3s}.ct-menubar-item:hover{background:rgba(0,0,0,.07)}.ct-menubar-item-disabled{pointer-events:none;cursor:not-allowed;opacity:.3}.ct-menubar-item-active{background:rgba(0,0,0,.07)}";
styleInject(css_248z$4);

var CommonItem = function(props) {
    var manager = useContext(ManagerContext);
    var icon = props.icon, title = props.title, command = props.command, isActive = props.isActive, name = props.name, isDisabled = props.isDisabled, keyTips = props.keyTips;
    var handleClick = function() {
        command();
        // 需要聚焦在 modal 上的特殊处理
        if (![
            "link",
            "html",
            "markdown",
            "plantuml"
        ].includes(name)) {
            manager.editorView.focus();
        }
    };
    var disabled = isDisabled();
    var popTitle = useMemo(function() {
        if (keyTips) {
            return "".concat(title, " (").concat(keyTips, ")");
        }
        return title;
    }, [
        title,
        keyTips
    ]);
    return /*#__PURE__*/ React.createElement(Tooltips, {
        title: popTitle,
        disabled: disabled
    }, /*#__PURE__*/ React.createElement("div", {
        onClick: handleClick,
        className: classNames(classNamePrefix("menubar-item"), disabled ? classNamePrefix("menubar-item-disabled") : "", isActive() ? classNamePrefix("menubar-item-active") : "")
    }, icon ? /*#__PURE__*/ React.createElement("img", {
        src: icon,
        alt: title,
        "data-menu-key": name
    }) : null));
};

var css_248z$5 = ".ct-menubar-heading-item{font-weight:700}.ct-menubar-heading-item-h0{font-size:14px;line-height:20px;font-weight:unset}.ct-menubar-heading-item-h1{font-size:28px;line-height:36px}.ct-menubar-heading-item-h2{font-size:24px;line-height:32px}.ct-menubar-heading-item-h3{font-size:20px;line-height:28px}.ct-menubar-heading-item-h4{font-size:16px;line-height:24px}.ct-menubar-heading-item-h5{font-size:14px;line-height:22px}.ct-menubar-heading-item-h6{font-size:12px;line-height:20px}";
styleInject(css_248z$5);

var HeadingItem = function(param) {
    var headingList = param.headingList;
    var manager = useContext(ManagerContext);
    var handleClick = useCallback(function(command) {
        command();
        manager.editorView.focus();
    }, []);
    var list = useMemo(function() {
        return headingList.map(function(item, index) {
            var title = item.title, command = item.command;
            return /*#__PURE__*/ React.createElement(Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classNames(classNamePrefix("menubar-heading-item"), classNamePrefix("menubar-heading-item-h".concat(index)))
            }, /*#__PURE__*/ React.createElement("span", null, title));
        });
    }, [
        headingList
    ]);
    var test = useMemo(function() {
        return 1;
    }, [
        manager
    ]);
    // 获取菜单栏段落下拉列表激活态
    var headingLabel = [
        i18nClient.t("pk_text", "正文"),
        i18nClient.t("h1", "标题 1"),
        i18nClient.t("h2", "标题 2"),
        i18nClient.t("h3", "标题 3"),
        i18nClient.t("h4", "标题 4"),
        i18nClient.t("h5", "标题 5"),
        i18nClient.t("h6", "标题 6")
    ];
    var level = manager.commands.heading.headingLevel();
    var activeHeading = headingLabel[level];
    var isDisabled = headingList[headingList.length - 1].isDisabled();
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 120,
        buttonWidth: 80,
        title: activeHeading,
        tips: "段落格式",
        className: classNamePrefix("menubar-heading"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var findFontSizeEmpty = function(state, defaultSize) {
    var _selection_$cursor;
    var schema = state.schema, selection = state.selection, tr = state.tr;
    var font = schema.marks.font;
    // 选区为空的情况
    var storedMarks = tr.storedMarks || state.storedMarks || ((_selection_$cursor = selection.$cursor) === null || _selection_$cursor === void 0 ? void 0 : _selection_$cursor.marks()) || [];
    var sm = storedMarks.find(function(m) {
        return m.type === font;
    });
    return sm ? sm.attrs.dataSize : defaultSize;
};
var findFontSizeRange = function(state, defaultSize) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var text = schema.nodes.text;
    var font = schema.marks.font;
    var ranges = selection.ranges;
    var lastFontSize = null;
    var retFlag = false;
    ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        // 如果选中的文本包含多个字号格式，则留空展示
        doc.nodesBetween(from, to, function(node, pos, parent, index) {
            if (retFlag) return;
            if (node.type !== text) return;
            var findMark = node.marks.find(function(mark) {
                return mark.type === font;
            });
            if (!findMark) {
                if (lastFontSize && lastFontSize !== defaultSize) {
                    lastFontSize = null;
                    retFlag = true;
                    return;
                }
                lastFontSize = defaultSize;
                return;
            }
            var fontSize = findMark.attrs.dataSize || defaultSize;
            if (index === 0) {
                lastFontSize = fontSize;
                return;
            }
            if (lastFontSize && lastFontSize !== fontSize) {
                lastFontSize = null;
                retFlag = true;
                return;
            }
            lastFontSize = fontSize;
        });
    });
    return lastFontSize;
};
// 获取菜单栏字号下拉列表激活态真实字号
var findActiveFontSize = function(state, defaultSize) {
    var selection = state.selection;
    var empty = selection.empty;
    // 选区为空的情况
    if (empty) return findFontSizeEmpty(state, defaultSize);
    // 选区为范围的情况
    return findFontSizeRange(state, defaultSize);
};
/**
 * 获取当前选区设置的字体
 */ var getFontSize = function() {
    var defaultSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
    return function(state) {
        return findActiveFontSize(state, defaultSize);
    };
};

var findActiveFontSizeTitle = function(fontSize) {
    if (fontSize) {
        var found = fontSizeConfig.find(function(item) {
            return "".concat(item.fontSize) === "".concat(fontSize);
        });
        return found && found.title;
    }
    return "";
};
var FontItem = function(param) {
    var fontList = param.fontList;
    var manager = useContext(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = useMemo(function() {
        return fontList.map(function(item) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ React.createElement(Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classNamePrefix("menubar-font-item")
            }, icon ? /*#__PURE__*/ React.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ React.createElement("span", null, title));
        });
    }, [
        fontList
    ]);
    var activeFontSize = getFontSize(14)(manager.editorView.state);
    var activeFontSizeTitle = findActiveFontSizeTitle(activeFontSize);
    var isDisabled = fontList[fontList.length - 1].isDisabled();
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 52,
        buttonWidth: 45,
        title: activeFontSizeTitle,
        tips: "字体大小",
        className: classNamePrefix("menubar-font"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var css_248z$6 = ".ct-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:240px;height:156px;bottom:-165px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.ct-color-popover .default .color-grid{border:none}.ct-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.ct-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.ct-color-grid{margin:0 1px;width:16px;height:16px;cursor:pointer;border:1px solid #fff}.ct-color-grid:nth-child(2){border:1px solid #eee;width:14px;height:14px;margin:1px 2px}.ct-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff}.ct-color-grid:hover{z-index:3;border-radius:1px}.ct-color-grid:hover:nth-child(2){box-shadow:0 0 0 2px #fff}.ct-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.ct-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.ct-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.ct-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.ct-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.ct-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.ct-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.ct-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.ct-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.ct-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.ct-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.ct-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.ct-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.ct-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.ct-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.ct-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.ct-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.ct-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.ct-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.ct-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.ct-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.ct-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.ct-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.ct-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.ct-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.ct-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.ct-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.ct-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.ct-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.ct-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.ct-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.ct-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.ct-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.ct-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.ct-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.ct-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.ct-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.ct-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.ct-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.ct-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.ct-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.ct-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.ct-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.ct-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.ct-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.ct-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.ct-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.ct-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.ct-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.ct-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.ct-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.ct-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.ct-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.ct-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.ct-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.ct-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.ct-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.ct-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.ct-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.ct-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.ct-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.ct-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.ct-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.ct-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.ct-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.ct-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.ct-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.ct-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.ct-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.ct-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.ct-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}.ct-color-grid:hover:nth-child(2){box-shadow:0 0 0 2px #ddd;width:16px;height:16px;margin:0 1px}";
styleInject(css_248z$6);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ColorPicker = /*#__PURE__*/ function(Component) {
    _inherits(ColorPicker, Component);
    var _super = _createSuper(ColorPicker);
    function ColorPicker() {
        _classCallCheck$1(this, ColorPicker);
        return _super.apply(this, arguments);
    }
    var _proto = ColorPicker.prototype;
    _proto.render = function render() {
        var _this_props = this.props, type = _this_props.type, _this_props_defaultColor = _this_props.defaultColor, defaultColor = _this_props_defaultColor === void 0 ? "" : _this_props_defaultColor, onSelect = _this_props.onSelect, selectedColor = _this_props.selectedColor;
        var colorGrids = colors.map(function(color, index) {
            return /*#__PURE__*/ React.createElement("div", {
                key: color,
                onClick: function() {
                    return onSelect(color);
                },
                className: classNames(classNamePrefix("color-grid"), {
                    selected: selectedColor === color,
                    "has-margin": index >= 10 && index < 20
                }),
                style: {
                    background: color,
                    boxShadow: selectedColor === color ? "0 0 0 2px ".concat(color) : ""
                }
            });
        });
        return /*#__PURE__*/ React.createElement("div", {
            "data-action": "".concat(type, "-color"),
            className: "".concat(classNamePrefix("color-popover"))
        }, /*#__PURE__*/ React.createElement("div", {
            onClick: function() {
                return onSelect(defaultColor);
            },
            className: "default"
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                background: defaultColor,
                borderColor: defaultColor
            },
            className: "color-grid"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "text"
        }, "恢复默认")), colorGrids);
    };
    return ColorPicker;
}(Component);

var img$C = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='10px' height='10px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3eA%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='06%e3%80%81%e7%bc%96%e8%be%91%e9%a1%b5-%e4%b8%8d%e5%8f%af%e6%9f%a5%e7%9c%8b%e5%ae%8f%ef%bc%881024%ef%bc%89' transform='translate(-448.000000%2c -21.000000)' fill='%23666666'%3e %3cg id='Group'%3e %3cg id='Group-8' transform='translate(20.000000%2c 15.000000)'%3e %3cg id='%e6%96%87%e5%ad%97%e9%a2%9c%e8%89%b2' transform='translate(420.000000%2c 0.000000)'%3e %3cg id='Group-6' transform='translate(6.000000%2c 6.000000)'%3e %3cpath d='M8.61943991%2c5.90197413 L7.01082031%2c1.48400272 L5.30121115%2c5.90197413 L8.61943991%2c5.90197413 Z M6.26061207%2c0 L7.88365875%2c0 L11.728476%2c10 L10.1559241%2c10 L9.08110652%2c7.00476515 L4.89003932%2c7.00476515 L3.74308634%2c10 L2.27152402%2c10 L6.26061207%2c0 Z' id='A'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var css_248z$7 = ".ct-color-popover[data-action=text-color] .default .color-grid{background-color:#333}.ct-menubar-color .icon-wrap{height:100%;display:flex;align-items:center}.ct-menubar-color .font-icon{padding:0 4px 3px 7px;font-size:0}.ct-menubar-color .font-icon .color-icon{width:10px;margin:0 2px 2px}.ct-menubar-color .font-icon .color-line{width:14px;height:3px;position:absolute;bottom:5px;left:10px}.ct-menubar-color .arrow:hover{background:rgba(0,0,0,.07)}";
styleInject(css_248z$7);

function _arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$3(arr, i) {
    return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$3();
}
function _unsupportedIterableToArray$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
}
var ColorItem = function(param) {
    var menuInfo = param.menuInfo;
    var manager = useContext(ManagerContext);
    var _useState = _slicedToArray$3(useState("#333"), 2), currentColor = _useState[0], setCurrentColor = _useState[1];
    var onClickIcon = function(e) {
        e.stopPropagation();
        menuInfo.command(currentColor);
        manager.editorView.focus();
    };
    var onClickColor = function(color) {
        menuInfo.command(color);
        manager.editorView.focus();
        setCurrentColor(color);
    };
    var list = useMemo(function() {
        return /*#__PURE__*/ React.createElement(ColorPicker, {
            type: "text",
            defaultColor: "",
            selectedColor: currentColor,
            onSelect: onClickColor
        });
    }, [
        currentColor
    ]);
    var customButton = useMemo(function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "icon-wrap"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "font-icon",
            onClick: onClickIcon
        }, /*#__PURE__*/ React.createElement("img", {
            src: img$C,
            className: "color-icon",
            alt: "font_icon"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "color-line",
            style: {
                background: currentColor || "#333"
            }
        }))), /*#__PURE__*/ React.createElement("span", {
            className: "arrow"
        }, /*#__PURE__*/ React.createElement("img", {
            src: img$B,
            alt: "triangle"
        })));
    }, [
        currentColor
    ]);
    var isDisabled = menuInfo.isDisabled() || false;
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        buttonWidth: 46,
        width: 0,
        tips: "文字颜色",
        className: classNamePrefix("menubar-color"),
        isDisabled: isDisabled
    }, customButton);
};

var SubsupItem = function(param) {
    var subsupList = param.subsupList;
    var manager = useContext(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = useMemo(function() {
        return subsupList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ React.createElement(Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classNames(classNamePrefix("menubar-subsup-item"), classNamePrefix("menubar-subsup-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ React.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ React.createElement("span", null, title));
        });
    }, [
        subsupList
    ]);
    var isDisabled = subsupList.reduce(function(prev, cur) {
        return prev || cur.isDisabled();
    }, false);
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 100,
        buttonWidth: 40,
        icon: subsupList[0].icon,
        tips: "文字其他",
        className: classNamePrefix("menubar-subsup"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var AlignItem = function(param) {
    var alignList = param.alignList;
    var manager = useContext(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = useMemo(function() {
        return alignList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ React.createElement(Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classNames(classNamePrefix("menubar-align-item"), classNamePrefix("menubar-align-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ React.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ React.createElement("span", null, title));
        });
    }, [
        alignList
    ]);
    var isDisabled = alignList.reduce(function(prev, cur) {
        return prev || cur.isDisabled();
    }, false);
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 100,
        buttonWidth: 40,
        icon: alignList[0].icon,
        tips: "对齐方式",
        className: classNamePrefix("menubar-align"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var NoteItem = function(param) {
    var noteList = param.noteList;
    var manager = useContext(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = useMemo(function() {
        return noteList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ React.createElement(Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classNames(classNamePrefix("menubar-note-item"), classNamePrefix("menubar-note-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ React.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ React.createElement("span", null, title));
        });
    }, [
        noteList
    ]);
    var isDisabled = noteList.reduce(function(prev, cur) {
        return prev || cur.isDisabled();
    }, false);
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 100,
        buttonWidth: 50,
        icon: noteList[0].icon,
        tips: "样式",
        className: classNamePrefix("menubar-note"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var TablePopup = /*#__PURE__*/ forwardRef(function(param, ref) {
    var highlight = param.highlight, current = param.current, onMouseMove = param.onMouseMove, command = param.command;
    var grids = useMemo(function() {
        var rows = [];
        var rowNum = highlight.rowNum, colNum = highlight.colNum;
        var rowCount = current.rowCount, colCount = current.colCount;
        Array.from({
            length: rowCount
        }).forEach(function(row, rowIndex) {
            var blocks = [];
            Array.from({
                length: colCount
            }).forEach(function(col, colIndex) {
                if (rowNum >= rowIndex + 1 && colNum >= colIndex + 1) {
                    blocks.push(/*#__PURE__*/ React.createElement("div", {
                        key: colIndex,
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        className: "block"
                    }, /*#__PURE__*/ React.createElement("span", {
                        className: "block-inner",
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        style: {
                            backgroundColor: "rgba(0, 0, 0, 0.13)"
                        }
                    })));
                } else {
                    blocks.push(/*#__PURE__*/ React.createElement("div", {
                        key: colIndex,
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        className: "block"
                    }, /*#__PURE__*/ React.createElement("span", {
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        className: "block-inner"
                    })));
                }
            });
            rows.push(/*#__PURE__*/ React.createElement("div", {
                className: "row",
                style: {
                    height: "24px"
                },
                "data-row": rowIndex,
                key: rowIndex
            }, blocks));
        });
        return rows;
    }, [
        highlight,
        current
    ]);
    var onClick = useCallback(function() {
        var rowNum = highlight.rowNum, colNum = highlight.colNum;
        command({
            rowCnt: rowNum,
            colCnt: colNum
        });
    }, [
        highlight
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        onMouseMove: onMouseMove,
        className: classNamePrefix("add-table-popup"),
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("div", null, grids), /*#__PURE__*/ React.createElement("div", {
        className: "count"
    }, "".concat(highlight.rowNum, " \xd7 ").concat(highlight.colNum)));
});

var css_248z$8 = ".ct-add-table-popup{padding:12px;cursor:pointer}.ct-add-table-popup .block{width:24px;height:24px;background:#fff;display:inline-block;box-sizing:border-box;border-radius:2px}.ct-add-table-popup .block .block-inner{margin:4px;box-sizing:border-box;border:1px solid rgba(0,0,0,.13);display:inline-block;width:16px;height:16px;border-radius:2px;background:#fff}.ct-add-table-popup .count{text-align:center;font-size:12px;color:rgba(0,0,0,.38);letter-spacing:0;line-height:20px}";
styleInject(css_248z$8);

function _arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$4(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$4(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$4(arr, i) {
    return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$4();
}
function _unsupportedIterableToArray$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}
var tableConfig = {
    max: 10,
    default: 6,
    itemWidth: 24
};
function adjustNum(num) {
    // 取整
    if (num < 1) return 1;
    if (num >= tableConfig.max) return tableConfig.max;
    return ~~num;
}
var TableItem = function(props) {
    var popupRef = useRef(null);
    var manager = useContext(ManagerContext);
    var _useState = _slicedToArray$4(useState({
        rowCount: tableConfig.default,
        colCount: tableConfig.default
    }), 2), current = _useState[0], setCurrent = _useState[1];
    var _useState1 = _slicedToArray$4(useState({
        rowNum: 1,
        colNum: 1
    }), 2), highlight = _useState1[0], setCurrentHighlight = _useState1[1];
    var onVisibleChange = function() {
        setCurrent({
            rowCount: tableConfig.default,
            colCount: tableConfig.default
        });
        setCurrentHighlight({
            rowNum: 1,
            colNum: 1
        });
    };
    var onMouseMove = useCallback(function(e) {
        var rowCount = current.rowCount, colCount = current.colCount;
        var _popupRef_current_getBoundingClientRect = popupRef.current.getBoundingClientRect(), left = _popupRef_current_getBoundingClientRect.left, top = _popupRef_current_getBoundingClientRect.top;
        var deltaColumn = adjustNum((e.clientX - left + tableConfig.itemWidth / 2) / tableConfig.itemWidth); // rightX  鼠标到 弹出框 左边的格子数
        var deltaRow = adjustNum((e.clientY - top + tableConfig.itemWidth / 2) / tableConfig.itemWidth); //  topY 鼠标到弹出框 上方的距离 到上方的格子数
        var newRowNum = deltaRow;
        var newColNum = deltaColumn;
        var newColCount = colCount;
        var newRowCount = rowCount;
        if (deltaColumn >= colCount && colCount < tableConfig.max) {
            newColCount = colCount + 1;
        } else if (deltaColumn < colCount - 1 && colCount > 7) {
            newColCount = deltaColumn - 1;
        }
        if (deltaRow >= rowCount && rowCount < tableConfig.max) {
            newRowCount = rowCount + 1;
        } else if (deltaRow < rowCount - 1 && rowCount > 7) {
            newRowCount = deltaRow - 1;
        }
        setCurrent({
            rowCount: newRowCount,
            colCount: newColCount
        });
        setCurrentHighlight({
            rowNum: newRowNum,
            colNum: newColNum
        });
    }, [
        current
    ]);
    var icon = props.icon, title = props.title, command = props.command, isDisabled = props.isDisabled;
    var width = useMemo(function() {
        return (current.colCount + 1) * 24;
    }, [
        current
    ]);
    var isTableDisabled = isDisabled();
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: /*#__PURE__*/ React.createElement(TablePopup, {
            ref: popupRef,
            onMouseMove: onMouseMove,
            highlight: highlight,
            current: current,
            command: command
        }),
        onVisibleChange: onVisibleChange,
        width: width,
        icon: icon,
        tips: title,
        className: classNamePrefix("menubar-table"),
        isDisabled: isTableDisabled,
        hasArrow: true
    });
};

var css_248z$9 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
styleInject(css_248z$9);

function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var Button = /*#__PURE__*/ function(Component) {
    _inherits$1(Button, Component);
    var _super = _createSuper$1(Button);
    function Button() {
        _classCallCheck$2(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, type = _this_props.type, _this_props_prefix = _this_props.prefix, prefix = _this_props_prefix === void 0 ? "button" : _this_props_prefix, disabled = _this_props.disabled, onClick = _this_props.onClick;
        var customPrefix = classNamePrefix(prefix);
        var classes = _defineProperty$3({}, "".concat(customPrefix, "-disabled"), disabled);
        if (type) {
            classes["".concat(customPrefix, "-").concat(type)] = true;
        }
        return /*#__PURE__*/ React.createElement("button", {
            disabled: disabled,
            className: classNames(customPrefix, classes),
            onClick: onClick
        }, children);
    };
    return Button;
}(Component);

var css_248z$a = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
styleInject(css_248z$a);

/* eslint-disable jsx-a11y/control-has-associated-label */ function _assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$2(self);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
var _typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$2(this, result);
    };
}
var defaultModalWidth = {
    small: 400,
    middle: 600,
    large: 800,
    super: 960
};
var Modal = /*#__PURE__*/ function(Component) {
    _inherits$2(Modal, Component);
    var _super = _createSuper$2(Modal);
    function Modal() {
        _classCallCheck$3(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onKeyDown = function(e) {
            var _this_props = _this.props, onOk = _this_props.onOk, canEnter = _this_props.canEnter;
            if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
                onOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, className = _this_props.className, title = _this_props.title, contentClassName = _this_props.contentClassName, _this_props_okText = _this_props.okText, okText = _this_props_okText === void 0 ? i18nClient.t("pk_confirm", "确定") : _this_props_okText, _this_props_cancelText = _this_props.cancelText, cancelText = _this_props_cancelText === void 0 ? i18nClient.t("pk_cancel", "取消") : _this_props_cancelText, onOk = _this_props.onOk, disabled = _this_props.disabled, onCancel = _this_props.onCancel, _this_props_showFooter = _this_props.showFooter, showFooter = _this_props_showFooter === void 0 ? true : _this_props_showFooter, wrapper = _this_props.wrapper, userPrefix = _this_props.prefix, size = _this_props.size;
        var prefix = classNamePrefix(userPrefix);
        return /*#__PURE__*/ ReactDom.createPortal(/*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "mask"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-content ").concat(contentClassName || ""),
            style: {
                width: defaultModalWidth[size]
            },
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-header")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-header-title")
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-header-close"),
            onClick: onCancel
        }, /*#__PURE__*/ React.createElement("button", {
            className: "".concat(prefix, "-header-close-icon")
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-body")
        }, children), showFooter && /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-footer")
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: onCancel
        }, cancelText), /*#__PURE__*/ React.createElement(Button, {
            type: "primary",
            className: "ok",
            onClick: onOk,
            disabled: disabled
        }, okText)))), wrapper || document.body);
    };
    return Modal;
}(Component);
Modal.defaultProps = {
    prefix: "base-modal",
    size: "middle",
    canEnter: false
};

var colors$1 = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];

function _assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$3(o) {
    _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$3(o);
}
function _inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _possibleConstructorReturn$3(self, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$3(self);
}
function _setPrototypeOf$3(o, p) {
    _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$3(o, p);
}
var _typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$3(this, result);
    };
}
var PopItem = /*#__PURE__*/ function(Component) {
    _inherits$3(PopItem, Component);
    var _super = _createSuper$3(PopItem);
    function PopItem() {
        _classCallCheck$4(this, PopItem);
        return _super.apply(this, arguments);
    }
    var _proto = PopItem.prototype;
    _proto.render = function render() {
        var _this_props = this.props, type = _this_props.type, defaultColor = _this_props.defaultColor, onSelect = _this_props.onSelect, selectedColor = _this_props.selectedColor;
        var colorGrids = colors$1.map(function(color, index) {
            return /*#__PURE__*/ React.createElement("div", {
                key: color,
                onClick: function() {
                    return onSelect(color);
                },
                className: classNames(classNamePrefix("table-color-grid"), {
                    selected: selectedColor === color,
                    "has-margin": index >= 10 && index < 20
                }),
                style: {
                    background: color
                }
            });
        });
        return /*#__PURE__*/ React.createElement("div", {
            "data-action": "".concat(type, "-color"),
            className: "".concat(classNamePrefix("table-color-popover"))
        }, /*#__PURE__*/ React.createElement("div", {
            onClick: function() {
                return onSelect(defaultColor);
            },
            className: "default"
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                background: defaultColor,
                borderColor: defaultColor
            },
            className: "color-grid"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "text"
        }, i18nClient.t("pk_restore", "恢复默认"))), colorGrids);
    };
    return PopItem;
}(Component);

var css_248z$b = '.ct-table-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:246px;font-size:12px;cursor:pointer;transition:all .2s ease}.ct-table-color-popover-wrapper .color-block{display:flex;justify-content:flex-start;align-items:baseline;width:246px;height:24px;padding:6px 8px;border:1px solid #ddd;border-radius:2px}.ct-table-color-popover-wrapper .color-block .left{width:100%;height:100%;margin-right:10px}.ct-table-color-popover-wrapper .color-block .right{width:14px;height:100%;background:url("data:image/svg+xml,%3Csvg width%3D%227px%22 height%3D%224px%22 viewBox%3D%220 0 7 4%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%2220%E3%80%81%E5%AF%8C%E6%96%87%E6%9C%AC%E7%BC%96%E8%BE%91%22 transform%3D%22translate(-521.000000%2C -82.000000)%22 fill%3D%22%23AEAEAE%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 56.000000)%22%3E                %3Cg id%3D%22Group-8%22 transform%3D%22translate(258.500000%2C 15.000000)%22%3E                    %3Cg id%3D%22%E5%AD%97%E5%8F%B7%22 transform%3D%22translate(223.000000%2C 0.000000)%22%3E                        %3Cpolygon id%3D%22%E5%BD%A2%E7%8A%B6_32%22 points%3D%2240 11.5 46 11.5 43 14.5%22%3E%3C%2Fpolygon%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-table-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-table-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.ct-table-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.ct-table-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.ct-table-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.ct-table-color-grid:nth-child(2),.ct-table-color-grid:nth-child(12){border:1px solid #eee}.ct-table-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.ct-table-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.ct-table-color-grid:hover:nth-child(2),.ct-table-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}.ct-table-color-grid:hover:nth-child(2){box-shadow:0 0 0 2px #fff}.ct-table-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.ct-table-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.ct-table-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.ct-table-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.ct-table-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.ct-table-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.ct-table-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.ct-table-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.ct-table-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.ct-table-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.ct-table-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.ct-table-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.ct-table-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.ct-table-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.ct-table-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.ct-table-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.ct-table-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.ct-table-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.ct-table-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.ct-table-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.ct-table-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.ct-table-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.ct-table-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.ct-table-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.ct-table-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.ct-table-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.ct-table-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.ct-table-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.ct-table-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.ct-table-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.ct-table-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.ct-table-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.ct-table-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.ct-table-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.ct-table-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.ct-table-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.ct-table-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.ct-table-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.ct-table-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.ct-table-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.ct-table-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.ct-table-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.ct-table-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.ct-table-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.ct-table-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.ct-table-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.ct-table-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.ct-table-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.ct-table-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.ct-table-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.ct-table-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.ct-table-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.ct-table-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.ct-table-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.ct-table-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.ct-table-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.ct-table-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.ct-table-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.ct-table-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.ct-table-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.ct-table-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.ct-table-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.ct-table-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.ct-table-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.ct-table-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.ct-table-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.ct-table-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.ct-table-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.ct-table-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.ct-table-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.ct-table-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}';
styleInject(css_248z$b);

/* eslint-disable react/destructuring-assignment */ function _assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$4(o) {
    _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$4(o);
}
function _inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$4(subClass, superClass);
}
function _possibleConstructorReturn$4(self, call) {
    if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$4(self);
}
function _setPrototypeOf$4(o, p) {
    _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$4(o, p);
}
var _typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$4(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$4(this, result);
    };
}
var ColorPopover = /*#__PURE__*/ function(Component) {
    _inherits$4(ColorPopover, Component);
    var _super = _createSuper$4(ColorPopover);
    function ColorPopover(props) {
        _classCallCheck$5(this, ColorPopover);
        var _this;
        _this = _super.call(this, props);
        // 接收来自 Popover 的选中事件后，调用父级 transform 方法
        _this.onSelect = function(color) {
            var setColor = _this.props.setColor;
            setColor(color);
            // HACK 异步 setState 以确保 tooltip 关闭
            window.requestAnimationFrame(function() {
                _this.setState({
                    hasTooltip: false,
                    isOpen: false
                });
            });
        };
        _this.handleMouseEnter = function() {
            var isOpen = _this.state.isOpen;
            if (isOpen) return;
            _this.setState({
                hasTooltip: true
            });
        };
        _this.state = {
            hasTooltip: false,
            isOpen: false
        };
        return _this;
    }
    var _proto = ColorPopover.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, type = _this_props.type, tips = _this_props.tips, defaultColor = _this_props.defaultColor, selectedColor = _this_props.selectedColor;
        var _this_state = this.state, hasTooltip = _this_state.hasTooltip, isOpen = _this_state.isOpen;
        return /*#__PURE__*/ React.createElement("div", {
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: function() {
                return _this.setState({
                    hasTooltip: false
                });
            },
            onClick: function() {
                return _this.setState({
                    isOpen: !isOpen
                });
            },
            className: "".concat(classNamePrefix("table-color-popover-wrapper"), " ").concat(type, "-color")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "color-block"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "left",
            style: {
                backgroundColor: selectedColor
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: "right"
        })), isOpen && /*#__PURE__*/ React.createElement(PopItem, {
            type: type,
            defaultColor: defaultColor,
            selectedColor: selectedColor,
            onSelect: this.onSelect
        }), hasTooltip && /*#__PURE__*/ React.createElement("div", {
            className: "ct-toolbar-tooltip"
        }, tips));
    };
    return ColorPopover;
}(Component);

var css_248z$c = '.table-modal-content{display:flex;justify-content:flex-start;align-items:baseline;padding:24px}.table-modal-content .left{display:flex;flex-direction:column;justify-content:space-between;width:246px;height:176px;margin-right:30px}.table-modal-content .right{width:300px}.table-modal-content .title{margin-bottom:8px;font-size:14px;color:#333;line-height:22px}.table-modal-content .style-wrapper{display:flex;justify-content:flex-start;align-items:baseline}.table-modal-content .style-item{width:76px;height:70px;text-align:center}.table-modal-content .dashed{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2242px%22 viewBox%3D%220 0 48 42%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E8%99%9A%E7%BA%BF%E6%A1%86%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E8%A1%A8%E6%A0%BC%E5%B1%9E%E6%80%A7%22%3E            %3Cpath d%3D%22M45%2C16.5 L45%2C10.5 L48%2C10.5 L48%2C16.5 L45%2C16.5 Z M45%2C25.5 L48%2C25.5 L48%2C31.5 L45%2C31.5 L45%2C25.5 Z M45%2C34.5 L48%2C34.5 L48%2C36 C48%2C39.3137085 45.3137085%2C42 42%2C42 L37.4854431%2C42 L37.4854431%2C39 L42%2C39 C43.6568542%2C39 45%2C37.6568542 45%2C36 L45%2C34.5 Z M34.4854431%2C39 L34.4854431%2C42 L28.4854431%2C42 L28.4854431%2C39 L34.4854431%2C39 Z M19.4854431%2C39 L19.4854431%2C42 L13.4854431%2C42 L13.4854431%2C39 L19.4854431%2C39 Z M10.4854431%2C39 L10.4854431%2C42 L6%2C42 C2.6862915%2C42 0%2C39.3137085 0%2C36 L0%2C34.5 L3%2C34.5 L3%2C36 C3%2C37.6568542 4.34314575%2C39 6%2C39 L10.4854431%2C39 Z M3%2C31.5 L0%2C31.5 L0%2C25.5 L3%2C25.5 L3%2C31.5 Z M3%2C16.5 L0%2C16.5 L0%2C10.5 L3%2C10.5 L3%2C16.5 Z M3%2C7.5 L0%2C7.5 L0%2C6 C0%2C2.6862915 2.6862915%2C0 6%2C0 L10.4854431%2C0 L10.4854431%2C3 L6%2C3 C4.34314575%2C3 3%2C4.34314575 3%2C6 L3%2C7.5 Z M13.4854431%2C3 L13.4854431%2C0 L19.4854431%2C0 L19.4854431%2C3 L13.4854431%2C3 Z M28.4854431%2C3 L28.4854431%2C0 L34.4854431%2C0 L34.4854431%2C3 L28.4854431%2C3 Z M37.4854431%2C3 L37.4854431%2C0 L42%2C0 C45.3137085%2C0 48%2C2.6862915 48%2C6 L48%2C7.5 L45%2C7.5 L45%2C6 C45%2C4.34314575 43.6568542%2C3 42%2C3 L37.4854431%2C3 Z%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E            %3Cpath d%3D%22M25.4854431%2C22.5 L25.4854431%2C31.538842 L22.4854431%2C31.538842 L22.4854431%2C22.5 L10.2857143%2C22.5 L10.2857143%2C19.5 L22.4854431%2C19.5 L22.4854431%2C10.461158 L25.4854431%2C10.461158 L25.4854431%2C19.5 L37.7142857%2C19.5 L37.7142857%2C22.5 L25.4854431%2C22.5 Z M-2.27373675e-13%2C22.5 L-2.27373675e-13%2C19.5 L6.85714286%2C19.5 L6.85714286%2C22.5 L-2.27373675e-13%2C22.5 Z M41.1428571%2C22.5 L41.1428571%2C19.5 L48%2C19.5 L48%2C22.5 L41.1428571%2C22.5 Z M22.4854431%2C1.42108547e-14 L25.4854431%2C1.42108547e-14 L25.4854431%2C6.97410534 L22.4854431%2C6.97410534 L22.4854431%2C1.42108547e-14 Z M22.4854431%2C35.0258947 L25.4854431%2C35.0258947 L25.4854431%2C42 L22.4854431%2C42 L22.4854431%2C35.0258947 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23CCCCCC%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.table-modal-content .solid{margin-left:18px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2242px%22 viewBox%3D%220 0 48 42%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%AE%9E%E7%BA%BF%E6%A1%86%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-9%22%3E            %3Cpath d%3D%22M25.4854431%2C22.5 L25.4854431%2C31.538842 L22.4854431%2C31.538842 L22.4854431%2C22.5 L17.1428571%2C22.5 L10.2857143%2C22.5 L10.2857143%2C19.5 L17.1428571%2C19.5 L22.4854431%2C19.5 L22.4854431%2C10.461158 L25.4854431%2C10.461158 L25.4854431%2C19.5 L33.7302246%2C19.5 L37.7142857%2C19.5 L37.7142857%2C22.5 L33.7302246%2C22.5 L25.4854431%2C22.5 Z M0%2C22.5 L0%2C19.5 L6.85714286%2C19.5 L6.85714286%2C22.5 L0%2C22.5 Z M41.1428571%2C22.5 L41.1428571%2C19.5 L48%2C19.5 L48%2C22.5 L41.1428571%2C22.5 Z M22.4854431%2C0 L25.4854431%2C0 L25.4854431%2C6.97410534 L22.4854431%2C6.97410534 L22.4854431%2C0 Z M22.4854431%2C35.0258947 L25.4854431%2C35.0258947 L25.4854431%2C42 L22.4854431%2C42 L22.4854431%2C35.0258947 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23CCCCCC%22%3E%3C%2Fpath%3E            %3Cpath d%3D%22M6%2C3 C4.34314575%2C3 3%2C4.34314575 3%2C6 L3%2C36 C3%2C37.6568542 4.34314575%2C39 6%2C39 L42%2C39 C43.6568542%2C39 45%2C37.6568542 45%2C36 L45%2C6 C45%2C4.34314575 43.6568542%2C3 42%2C3 L6%2C3 Z M6%2C0 L42%2C0 C45.3137085%2C0 48%2C2.6862915 48%2C6 L48%2C36 C48%2C39.3137085 45.3137085%2C42 42%2C42 L6%2C42 C2.6862915%2C42 0%2C39.3137085 0%2C36 L0%2C6 C0%2C2.6862915 2.6862915%2C0 6%2C0 Z%22 id%3D%22Rectangle-15%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.table-modal-content .selected{background-color:rgba(0,167,205,.1)}.width-wrapper{padding:0 20px;display:flex;justify-content:space-around;align-items:center;flex-wrap:wrap;height:220px;border:1px solid #ddd;border-radius:2px;font-size:12px}.width-wrapper .width-item{cursor:pointer;width:126px;height:19px;line-height:19px;border-radius:2px;text-align:center;display:flex;align-items:center;justify-content:center}.width-wrapper .width-item .inner{display:inline-block;vertical-align:middle;width:110px;background:#1c6cdc}.width-wrapper .width-item:nth-child(2) .inner{height:4px}.width-wrapper .width-item:nth-child(3) .inner{height:1px}.width-wrapper .width-item:nth-child(4) .inner{height:5px}.width-wrapper .width-item:nth-child(5) .inner{height:2px}.width-wrapper .width-item:nth-child(6) .inner{height:6px}.width-wrapper .width-item:nth-child(7) .inner{height:3px}.width-wrapper .width-item:nth-child(8) .inner{height:7px}';
styleInject(css_248z$c);

function _assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$5(o) {
    _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$5(o);
}
function _inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$5(subClass, superClass);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn$5(self, call) {
    if (call && (_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$5(self);
}
function _setPrototypeOf$5(o, p) {
    _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$5(o, p);
}
var _typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$5(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$5(this, result);
    };
}
var TableModal = /*#__PURE__*/ function(Component) {
    _inherits$5(TableModal, Component);
    var _super = _createSuper$5(TableModal);
    function TableModal(props) {
        _classCallCheck$6(this, TableModal);
        var _this;
        _this = _super.call(this, props);
        _this.handleOk = function() {
            var _this_props = _this.props, setTableAttrs = _this_props.setTableAttrs, hideModal = _this_props.hideModal;
            setTableAttrs(_objectSpread$2({}, _this.state));
            hideModal();
        };
        _this.handleCancel = function() {
            var hideModal = _this.props.hideModal;
            hideModal();
        };
        var getTableAttrs = _this.props.getTableAttrs;
        var attrs = getTableAttrs();
        _this.state = {
            borderStyle: attrs.borderStyle || "solid",
            borderColor: attrs.borderColor || "#cccccc",
            borderWidth: attrs.borderWidth === null ? 1 : attrs.borderWidth
        };
        return _this;
    }
    var _proto = TableModal.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, borderStyle = _this_state.borderStyle, borderColor = _this_state.borderColor, borderWidth = _this_state.borderWidth;
        return /*#__PURE__*/ React.createElement(Modal, {
            className: "",
            contentClassName: "table-modal-wrapper",
            title: i18nClient.t("table_attr", "表格属性"),
            disabled: false,
            okText: i18nClient.t("pk_confirm", "确定"),
            onOk: this.handleOk,
            onCancel: function() {
                _this.handleCancel();
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: "table-modal-content"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "left"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "border-style"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "title"
        }, i18nClient.t("border_style", "边框样式"), "："), /*#__PURE__*/ React.createElement("div", {
            className: "style-wrapper"
        }, /*#__PURE__*/ React.createElement("div", {
            className: classNames("style-item dashed", {
                selected: borderStyle === "dashed"
            }),
            onClick: function() {
                return _this.setState({
                    borderStyle: "dashed"
                });
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: classNames("style-item solid", {
                selected: borderStyle === "solid"
            }),
            onClick: function() {
                return _this.setState({
                    borderStyle: "solid"
                });
            }
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "border-color"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "title"
        }, i18nClient.t("border_color", "边框颜色"), "："), /*#__PURE__*/ React.createElement(ColorPopover, {
            type: "table-border",
            tips: i18nClient.t("border_color", "边框颜色"),
            defaultColor: "#ccc",
            selectedColor: borderColor,
            setColor: function(color) {
                return _this.setState({
                    borderColor: color
                });
            }
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "right"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "border-width"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "title"
        }, i18nClient.t("border_width", "边框宽度"), "："), /*#__PURE__*/ React.createElement("div", {
            className: "width-wrapper"
        }, /*#__PURE__*/ React.createElement("div", {
            className: classNames("width-item", {
                selected: borderWidth === 0
            }),
            onClick: function() {
                return _this.setState({
                    borderWidth: 0
                });
            }
        }, i18nClient.t("pk_no", "无")), [
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ].map(function(_) {
            return /*#__PURE__*/ React.createElement("div", {
                key: _,
                className: classNames("width-item", {
                    selected: borderWidth === _
                }),
                onClick: function() {
                    return _this.setState({
                        borderWidth: _
                    });
                }
            }, /*#__PURE__*/ React.createElement("div", {
                className: "inner",
                style: {
                    backgroundColor: borderColor
                }
            }));
        }))))));
    };
    return TableModal;
}(Component);

var img$D = "data:image/svg+xml,%3csvg t='1570527618080' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4679' width='20' height='20'%3e %3cpath d='M298.666667 192h106.666666v64h-106.666666v96l-213.333334-128 213.333334-128V192z m469.333333 405.333333H128v-64h640v-149.333333h64v490.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H128v-64h640V597.333333zM469.333333 128h426.666667v192H469.333333V128z' fill='black' p-id='4680'%3e%3c/path%3e%3c/svg%3e";

var img$E = "data:image/svg+xml,%3csvg t='1570527687806' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4850' width='20' height='20'%3e %3cpath d='M298.666667 768h106.666666v64h-106.666666v96l-213.333334-128 213.333334-128V768z m469.333333-277.333333H128v-64h640V192H128V128h682.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v490.666667h-64v-149.333333zM469.333333 704h426.666667v192H469.333333v-192z' fill='black' p-id='4851'%3e%3c/path%3e%3c/svg%3e";

var img$F = "data:image/svg+xml,%3csvg t='1570527820427' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5444' width='20' height='20'%3e %3cpath d='M85.333333 608h512v-192H85.333333v192z m384 64V832H85.333333v64h426.666667a21.333333 21.333333 0 0 0 21.333333-21.333333v-202.666667h-64z m64-320V149.333333a21.333333 21.333333 0 0 0-21.333333-21.333333H85.333333v64h384v160h64z m149.333334 76.714667L765.952 512 682.666667 595.285333 727.381333 640 810.666667 556.714667 893.952 640 938.666667 595.285333 855.381333 512 938.666667 428.714667 893.952 384 810.666667 467.285333 727.381333 384 682.666667 428.714667z' fill='black' p-id='5445'%3e%3c/path%3e%3c/svg%3e";

var img$G = "data:image/svg+xml,%3csvg t='1570527734623' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5162' width='20' height='20'%3e %3cpath d='M256 298.666667v128H192v-128H96l128-213.333334 128 213.333334H256z m277.333333 448V128h64v618.666667h234.666667V128h64v661.333333a21.333333 21.333333 0 0 1-21.333333 21.333334H384v-64h149.333333zM128 469.333333h192v426.666667H128V469.333333z' fill='black' p-id='5163'%3e%3c/path%3e%3c/svg%3e";

var img$H = "data:image/svg+xml,%3csvg t='1570527713921' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4991' width='20' height='20'%3e %3cpath d='M832 298.666667v128h-64v-128h-96l128-213.333334 128 213.333334H832zM426.666667 746.666667V128h64v618.666667h149.333333v64H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333334V128h64v618.666667h234.666667z m277.333333-277.333334h192v426.666667h-192V469.333333z' fill='black' p-id='4992'%3e%3c/path%3e%3c/svg%3e";

var img$I = "data:image/svg+xml,%3csvg t='1570527768162' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5303' width='20' height='20'%3e %3cpath d='M608 128v426.666667h-192V128h192z m64 298.666667H874.666667V128h64v341.333333a21.333333 21.333333 0 0 1-21.333334 21.333334H672v-64z m-320 64H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333334V128h64v298.666667h202.666667v64z m76.181333 147.370666l84.266667 84.266667 84.266667-84.266667 45.226666 45.248-84.245333 84.266667 84.266667 84.266667-45.248 45.248-84.266667-84.266667-84.266667 84.266667-45.248-45.248 84.266667-84.266667-84.266667-84.266667 45.248-45.226666z' fill='black' p-id='5304'%3e%3c/path%3e%3c/svg%3e";

var img$J = "data:image/svg+xml,%3csvg t='1570527866151' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5585' width='20' height='20'%3e %3cpath d='M277.333333 544H192V832h192v-128h64v192H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667v192h-64V192H192v288h85.333333V384l213.333334 128-213.333334 128v-96zM640 832h192V544h-85.333333V640l-213.333334-128 213.333334-128v96h85.333333V192h-192v128h-64V128h298.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H576v-192h64v128z' fill='black' p-id='5586'%3e%3c/path%3e%3c/svg%3e";

var img$K = "data:image/svg+xml,%3csvg t='1570527885348' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5756' width='20' height='20'%3e %3cpath d='M896 704v170.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H576V128h298.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v170.666667h-64V192h-192v288h85.333333V384l213.333334 128-213.333334 128v-96h-85.333333V832h192v-128h64zM192 832h192V544h-85.333333V640L85.333333 512l213.333334-128v96h85.333333V192H192v128H128V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667v768H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333v-170.666667h64v128z' fill='black' p-id='5757'%3e%3c/path%3e%3c/svg%3e";

var img$L = "data:image/svg+xml,%3csvg t='1570609845934' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3713' width='20' height='20'%3e %3cpath d='M512 256l106.666667 178.986667h-74.666667V938.666667h-64V434.986667H405.333333L512 256z m384-138.666667v64H128v-64h768z' fill='black' p-id='3714'%3e%3c/path%3e%3c/svg%3e";

var img$M = "data:image/svg+xml,%3csvg t='1570609798139' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3542' width='20' height='20'%3e %3cpath d='M480 74.666667h64v503.68H618.666667l-106.666667 178.986666-106.666667-178.986666h74.666667V74.666667zM128 896v-64h768v64H128z' fill='black' p-id='3543'%3e%3c/path%3e%3c/svg%3e";

var img$N = "data:image/svg+xml,%3csvg t='1570529387197' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5897' width='20' height='20'%3e %3cpath d='M512 618.666667l106.666667 178.986666h-74.666667V938.666667h-64v-141.013334H405.333333L512 618.666667z m384-138.666667v64H128v-64h768zM544 85.333333v141.013334H618.666667L512 405.333333l-106.666667-178.986666h74.666667V85.333333h64z' fill='black' fill-opacity='.87' p-id='5898'%3e%3c/path%3e%3c/svg%3e";

var TableAlignItem = function() {
    var manager = useContext(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var alignList = [
        {
            title: "顶部对齐",
            icon: img$L,
            command: function() {
                return manager.commands.table.setCellVerticalAlign("top");
            }
        },
        {
            title: "居中对齐",
            icon: img$N,
            command: function() {
                return manager.commands.table.setCellVerticalAlign("middle");
            }
        },
        {
            title: "底部对齐",
            icon: img$M,
            command: function() {
                return manager.commands.table.setCellVerticalAlign("bottom");
            }
        }
    ];
    var list = useMemo(function() {
        return alignList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ React.createElement(Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classNames(classNamePrefix("menubar-table-align-item"), classNamePrefix("menubar-table-align-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ React.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ React.createElement("span", null, title));
        });
    }, [
        alignList
    ]);
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 120,
        buttonWidth: 40,
        icon: alignList[1].icon,
        tips: "上下对齐",
        className: classNamePrefix("menubar-table-align"),
        isDisabled: false,
        hasArrow: true
    });
};

var img$O = "data:image/svg+xml,%3csvg t='1570529706144' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6239' width='20' height='20'%3e %3cpath d='M426.666667 832h170.666666v-170.666667h-170.666666v170.666667z m-64 0v-170.666667H192v-64h170.666667v-170.666666H192v405.333333h170.666667z m64-405.333333v170.666666h170.666666v-170.666666h-170.666666z m234.666666 405.333333h170.666667V426.666667h-170.666667v170.666666h170.666667v64h-170.666667v170.666667zM896 149.333333v149.333334H128V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334a21.333333 21.333333 0 0 1 21.333333 21.333333z m0 213.333334v512a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V362.666667h768z' fill='black' p-id='6240'%3e%3c/path%3e%3c/svg%3e";

var img$P = "data:image/svg+xml,%3csvg t='1570529731401' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6410' width='20' height='20'%3e %3cpath d='M832 597.333333v-170.666666h-170.666667v170.666666h170.666667z m0 64h-170.666667v170.666667h-64v-170.666667h-170.666666v170.666667h405.333333v-170.666667z m-405.333333-64h170.666666v-170.666666h-170.666666v170.666666z m405.333333-234.666666V192H426.666667v170.666667h170.666666V192h64v170.666667h170.666667zM149.333333 128h149.333334v768H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333z m213.333334 0h512a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H362.666667V128z' fill='black' p-id='6411'%3e%3c/path%3e%3c/svg%3e";

var img$Q = "data:image/svg+xml,%3csvg t='1570529939900' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6581' width='20' height='20'%3e %3cpath d='M653.610667 432.277333l-211.2-211.178666-211.2 211.2h422.4zM397.162667 85.333333l331.861333 331.861334a21.333333 21.333333 0 0 1 0 30.186666L457.493333 718.890667a21.333333 21.333333 0 0 1-30.165333 0L155.797333 447.381333a21.333333 21.333333 0 0 1 0-30.186666L397.162667 175.850667 351.914667 130.56 397.162667 85.333333zM128 768h768v128H128v-128z m643.797333-59.669333a64 64 0 0 1-64-64c0-23.573333 21.333333-66.24 64-128 42.666667 61.76 64 104.426667 64 128a64 64 0 0 1-64 64z' fill='black' p-id='6582'%3e %3c/path%3e%3c/svg%3e";

var css_248z$d = ".ct-table-bg-color-popover[data-action=text-color] .default .color-grid{background-color:#333}.ct-menubar-table-bg-color .icon-wrap{height:100%;display:flex;align-items:center}.ct-menubar-table-bg-color .font-icon{padding:0 4px 3px 7px;font-size:0}.ct-menubar-table-bg-color .font-icon .color-icon{width:20px;margin:2px}.ct-menubar-table-bg-color .font-icon .color-line{width:16px;height:3px;position:absolute;bottom:7px;left:9px}.ct-menubar-table-bg-color .arrow:hover{background:rgba(0,0,0,.07)}";
styleInject(css_248z$d);

function _arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$5(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$5(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$5() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$5(arr, i) {
    return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$5();
}
function _unsupportedIterableToArray$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}
var TableBgColorItem = function() {
    var manager = useContext(ManagerContext);
    var _useState = _slicedToArray$5(useState(""), 2), currentColor = _useState[0], setCurrentColor = _useState[1];
    var onClickIcon = function(e) {
        e.stopPropagation();
        manager.commands.table.setCellBgColor(currentColor);
        manager.editorView.focus();
    };
    var onClickColor = function(color) {
        manager.commands.table.setCellBgColor(color);
        manager.editorView.focus();
        setCurrentColor(color);
    };
    var list = useMemo(function() {
        return /*#__PURE__*/ React.createElement(ColorPicker, {
            type: "text",
            defaultColor: "",
            selectedColor: currentColor,
            onSelect: onClickColor
        });
    }, [
        currentColor
    ]);
    var customButton = useMemo(function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "icon-wrap"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "font-icon",
            onClick: onClickIcon
        }, /*#__PURE__*/ React.createElement("img", {
            src: img$Q,
            className: "color-icon",
            alt: "font_icon"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "color-line",
            style: {
                background: currentColor || "#eee"
            }
        }))), /*#__PURE__*/ React.createElement("span", {
            className: "arrow"
        }, /*#__PURE__*/ React.createElement("img", {
            src: img$B,
            alt: "triangle"
        })));
    }, [
        currentColor
    ]);
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        buttonWidth: 46,
        width: 0,
        tips: "表格底色",
        className: classNamePrefix("menubar-table-bg-color"),
        isDisabled: false
    }, customButton);
};

var img$R = "data:image/svg+xml,%3csvg t='1570531313249' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6752' width='20' height='20'%3e %3cpath d='M704 832v64h-64v-64h64z m-224-64h64v64H576v64h-128v-64h32v-64zM384 832v64h-64v-64h64z m512-64v106.666667a21.333333 21.333333 0 0 1-21.333333 21.333333h-106.666667v-64h64v-64h64zM192 768v64h64v64H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333v-106.666667h64z m0-128v64H128v-64h64z m704 0v64h-64v-64h64z m-352 0v64h-64v-64h64zM896 448v128h-64v-32h-64v-64h64V448h64z m-352 0v32H576v64h-32V576h-64v-32H448v-64h32V448h64z m160 32v64h-64v-64h64z m-320 0v64h-64v-64h64zM896 320v64h-64v-64h64zM192 320v64H128v-64h64z m352 0v64h-64v-64h64zM874.666667 128a21.333333 21.333333 0 0 1 21.333333 21.333333v106.666667h-64V192h-64V128h106.666667zM256 128v64H192v64H128V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h106.666667z m192 64V128h128v64h-32v64h-64V192H448z m256-64v64h-64V128h64zM384 128v64h-64V128h64zM192 576H128v-128h64v32h64v64H192V576z' fill='black' p-id='6753'%3e%3c/path%3e%3c/svg%3e";

var img$S = "data:image/svg+xml,%3csvg t='1570531405018' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6983' width='20' height='20'%3e %3cpath d='M277.333333 213.333333V106.666667a21.333333 21.333333 0 0 1 21.333334-21.333334h426.666666a21.333333 21.333333 0 0 1 21.333334 21.333334v106.666666h192v64h-85.333334v640a21.333333 21.333333 0 0 1-21.333333 21.333334l-640-0.170667a21.333333 21.333333 0 0 1-21.333333-21.333333V277.333333H85.333333v-64h192z m405.333334 0V149.333333H341.333333v64h341.333334zM394.666667 448h64v256h-64V448z m170.666666 0h64v256h-64V448zM234.666667 278.528V874.666667h554.666666V277.333333l-554.666666 1.194667z' fill='black' p-id='6984'%3e%3c/path%3e%3c/svg%3e";

var TableWidthItem = function() {
    var manager = useContext(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var widthList = [
        {
            title: "固定宽度",
            icon: "",
            command: function() {
                return manager.commands.table.setFixed();
            }
        },
        {
            title: "自适应",
            icon: "",
            command: function() {
                return manager.commands.table.setResponsive();
            }
        }
    ];
    var list = useMemo(function() {
        return widthList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ React.createElement(Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classNames(classNamePrefix("menubar-table-width-item"), classNamePrefix("menubar-table-width-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ React.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ React.createElement("span", null, title));
        });
    }, [
        widthList
    ]);
    return /*#__PURE__*/ React.createElement(Dropdown, {
        popup: list,
        width: 120,
        buttonWidth: 100,
        title: manager.commands.table.isResponsive() ? "自适应" : "固定宽度",
        tips: "",
        className: classNamePrefix("menubar-table-align"),
        isDisabled: false,
        hasArrow: true
    });
};

function _arrayLikeToArray$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$6(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$6(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$6() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$6(arr, i) {
    return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$6();
}
function _unsupportedIterableToArray$7(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}
var TableMenu = function() {
    var manager = useContext(ManagerContext);
    var _useState = _slicedToArray$6(useState(false), 2), showAttrsModal = _useState[0], setShowAttrsModal = _useState[1];
    return /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("table-menubar-wrapper")
    }, /*#__PURE__*/ React.createElement(CommonItem, {
        key: "addRowBefore",
        icon: img$D,
        title: "上方插入行",
        command: manager.commands.table.addRowBefore,
        isDisabled: function() {
            return !manager.commands.table.canAddRowBefore();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "addRowAfter",
        icon: img$E,
        title: "下方插入行",
        command: manager.commands.table.addRowAfter,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "deleteRow",
        icon: img$F,
        title: "删除行",
        command: manager.commands.table.deleteRow,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "addColumnBefore",
        icon: img$G,
        title: "左侧插入列",
        command: manager.commands.table.addColumnBefore,
        isDisabled: function() {
            return !manager.commands.table.canAddColumnBefore();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "addColumnAfter",
        icon: img$H,
        title: "右侧插入列",
        command: manager.commands.table.addColumnAfter,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "deleteColumn",
        icon: img$I,
        title: "删除列",
        command: manager.commands.table.deleteColumn,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "mergeCells",
        icon: img$J,
        title: "合并单元格",
        command: manager.commands.table.mergeCells,
        isDisabled: function() {
            return !manager.commands.table.canMergeCells();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "splitCell",
        icon: img$K,
        title: "拆分单元格",
        command: manager.commands.table.splitCell,
        isDisabled: function() {
            return !manager.commands.table.canSplitCell();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement(TableAlignItem, null), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "tableRowHeader",
        icon: img$O,
        title: manager.commands.table.hasRowHeader() ? "取消表头行" : "设置表头行",
        command: manager.commands.table.toggleRowHeader,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "tableColHeader",
        icon: img$P,
        title: manager.commands.table.hasColHeader() ? "取消表头列" : "设置表头列",
        command: manager.commands.table.toggleColHeader,
        isDisabled: function() {
            return !manager.commands.table.canToggleColHeader();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement(TableBgColorItem, null), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "tableAttrs",
        icon: img$R,
        title: "表格属性",
        command: function() {
            return setShowAttrsModal(true);
        },
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), showAttrsModal && /*#__PURE__*/ React.createElement(TableModal, {
        hideModal: function() {
            return setShowAttrsModal(false);
        },
        setTableAttrs: manager.commands.table.setTableAttrs,
        getTableAttrs: manager.commands.table.getTableAttrs
    }), /*#__PURE__*/ React.createElement(CommonItem, {
        key: "deleteTable",
        icon: img$S,
        title: "删除表格",
        command: manager.commands.table.deleteTable,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement(TableWidthItem, null), /*#__PURE__*/ React.createElement("div", {
        className: classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ React.createElement("div", {
        onClick: function() {
            manager.commands.table.toggleNumCol();
            manager.editorView.focus();
        },
        className: classNames(classNamePrefix("menubar-item"), classNamePrefix("menubar-table-num-item"), manager.commands.table.canToggleNumCol() ? "" : classNamePrefix("menubar-item-disabled"), manager.commands.table.hasNumCol() ? classNamePrefix("menubar-item-active") : ""),
        style: {
            width: 120
        }
    }, "显示表格行号列"));
};

function _arrayLikeToArray$8(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$8(arr);
}
function _assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function _getPrototypeOf$6(o) {
    _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$6(o);
}
function _inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$6(subClass, superClass);
}
function _iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn$6(self, call) {
    if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$6(self);
}
function _setPrototypeOf$6(o, p) {
    _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$6(o, p);
}
function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$1();
}
var _typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray$8(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$8(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}
function _isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$6(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$6(this, result);
    };
}
var commonProcess = function(menuItem, manager) {
    var type = menuItem.type, config = menuItem.config;
    if (type === MenuType.Extra) {
        var _menuItem_children = menuItem.children, children = _menuItem_children === void 0 ? [] : _menuItem_children;
        return [
            /*#__PURE__*/ React.createElement(ExtraItem, {
                menuList: children,
                key: type
            })
        ];
    }
    var list = getMenuInfo(type, manager, config);
    if (type === MenuType.Subsup) {
        var subList = getMenuInfo(MenuType.Sub, manager, config) || [];
        var supList = getMenuInfo(MenuType.Sup, manager, config) || [];
        list = _toConsumableArray$1(subList).concat(_toConsumableArray$1(supList));
    }
    if (!list || !list.length) return [];
    switch(menuItem.type){
        case MenuType.Heading:
            {
                return [
                    /*#__PURE__*/ React.createElement(HeadingItem, {
                        headingList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Font:
            {
                return [
                    /*#__PURE__*/ React.createElement(FontItem, {
                        fontList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Color:
            {
                return [
                    /*#__PURE__*/ React.createElement(ColorItem, {
                        menuInfo: list[0],
                        key: type
                    })
                ];
            }
        case MenuType.Subsup:
            {
                return [
                    /*#__PURE__*/ React.createElement(SubsupItem, {
                        subsupList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Align:
            {
                return [
                    /*#__PURE__*/ React.createElement(AlignItem, {
                        alignList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Note:
            {
                return [
                    /*#__PURE__*/ React.createElement(NoteItem, {
                        noteList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Table:
            {
                return [
                    /*#__PURE__*/ React.createElement(TableItem, _extends$1({}, list[0], {
                        key: type
                    }))
                ];
            }
        default:
            return list.map(function(item) {
                return /*#__PURE__*/ React.createElement(CommonItem, _extends$1({
                    name: type,
                    key: item.title
                }, item));
            });
    }
};
var getMenuComponents = function(manager, menuConfig) {
    return menuConfig.reduce(function(prev, cur) {
        prev = _toConsumableArray$1(prev).concat(_toConsumableArray$1(commonProcess(cur, manager)));
        if (cur.divider) {
            prev = _toConsumableArray$1(prev).concat([
                /*#__PURE__*/ React.createElement("div", {
                    className: classNamePrefix("menubar-divider"),
                    key: Math.random()
                })
            ]);
        }
        return prev;
    }, []);
};
var Menubar = /*#__PURE__*/ function(Component) {
    _inherits$6(Menubar, Component);
    var _super = _createSuper$6(Menubar);
    function Menubar(props) {
        _classCallCheck$7(this, Menubar);
        var _this;
        _this = _super.call(this, props);
        _this.update = function(manager) {
            _this.setState({
                manager: manager
            });
        };
        var manager = props.manager, config = props.config;
        _this.state = {
            manager: manager,
            config: config
        };
        return _this;
    }
    var _proto = Menubar.prototype;
    _proto.render = function render() {
        var _this_state = this.state, manager = _this_state.manager, config = _this_state.config;
        var showTableMenu = manager.commands.table && manager.commands.table.isInTable();
        return /*#__PURE__*/ React.createElement(ManagerContext.Provider, {
            value: manager
        }, /*#__PURE__*/ React.createElement("div", {
            className: classNamePrefix("main-menubar-wrapper")
        }, getMenuComponents(manager, config)), showTableMenu && /*#__PURE__*/ React.createElement(TableMenu, null));
    };
    return Menubar;
}(Component);

var defaultMenuConfig = function() {
    return [
        {
            type: MenuType.History
        },
        {
            type: MenuType.ClearFormat,
            divider: true
        },
        {
            type: MenuType.Heading
        },
        {
            type: MenuType.Font
        },
        {
            type: MenuType.Bold
        },
        {
            type: MenuType.Italic
        },
        {
            type: MenuType.Strikethrough
        },
        {
            type: MenuType.Underline
        },
        {
            type: MenuType.Color
        },
        {
            type: MenuType.Subsup,
            divider: true
        },
        {
            type: MenuType.Align
        },
        {
            type: MenuType.BulletList
        },
        {
            type: MenuType.OrderedList
        },
        {
            type: MenuType.TaskList
        },
        {
            type: MenuType.Indent
        },
        {
            type: MenuType.Table
        },
        {
            type: MenuType.Image
        },
        {
            type: MenuType.Link
        },
        {
            type: MenuType.Code,
            divider: true
        },
        {
            type: MenuType.Extra,
            children: [
                {
                    type: MenuType.Catalog
                },
                {
                    type: MenuType.Attachment
                },
                {
                    type: MenuType.Video
                },
                {
                    type: MenuType.Audio
                },
                {
                    type: MenuType.Mention
                },
                {
                    type: MenuType.Status
                },
                {
                    type: MenuType.Note
                },
                {
                    type: MenuType.Blockquote
                },
                {
                    type: MenuType.Collapse
                },
                {
                    type: MenuType.HorizontalRule
                },
                {
                    type: MenuType.Drawio
                },
                {
                    type: MenuType.Minder
                },
                {
                    type: MenuType.Latex
                },
                {
                    type: MenuType.Html
                },
                {
                    type: MenuType.Time
                },
                {
                    type: MenuType.Markdown
                },
                {
                    type: MenuType.PlantUML
                }
            ]
        }
    ];
};

var css_248z$e = ".ct-menubar-container{font-size:14px;position:relative;background:#fff;z-index:100}.ct-menubar-container .ct-main-menubar-wrapper,.ct-menubar-container .ct-table-menubar-wrapper{display:flex;flex-wrap:wrap}.ct-menubar-container .ct-menubar-divider{width:1px;height:15px;margin:auto 8px;background:#ddd}";
styleInject(css_248z$e);

function _classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var Menubar$1 = function Menubar$1(menubarDom) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultMenuConfig();
    var _this = this;
    _classCallCheck$8(this, Menubar$1);
    this.enhanceDom = function(dom) {
        dom.setAttribute("class", classNamePrefix("menubar-container"));
        _this.menuWrapper = dom;
    };
    this.connect = function(editor) {
        _this.editor = editor;
        _this.renderMenubar();
    };
    this.renderMenubar = function() {
        render(/*#__PURE__*/ React.createElement(Menubar, {
            manager: _this.editor.manager,
            config: _this.config,
            ref: _this.onRef
        }), _this.menuWrapper);
    };
    this.onRef = function(ref) {
        if (ref) {
            _this._menubarRef = ref;
        }
    };
    this.update = function() {
        if (_this._menubarRef) {
            _this._menubarRef.update(_this.editor.manager);
        }
    };
    this.editor = null;
    this.menuWrapper = null;
    this.menuComponent = null;
    this._menubarRef = null;
    this.enhanceDom(menubarDom);
    this.config = config;
};

export default Menubar$1;
//# sourceMappingURL=index.js.map
